var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 812,
    height: 495,
    viewBox: "0 0 812 495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3998",
    "data-name": "Rectangle 3998",
    width: 812,
    height: 495,
    transform: "translate(10840.156 306.039)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.27,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89d6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#278bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#154388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d78bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#154388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 54.189,
    y1: 0.21,
    x2: 54.152,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3175ba",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3175ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.867,
    y1: 0.023,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 54.128,
    y1: 0.21,
    x2: 54.092,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a6ab4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2b6cb5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.273,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 29.989,
    y1: 0.202,
    x2: 29.962,
    y2: 0.754,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#184aa0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#184aa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.867,
    y1: 0.025,
    x2: 0.613,
    y2: 1.269,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 54.182,
    y1: 0.21,
    x2: 54.144,
    y2: 0.762,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1.47,
    y1: 0.085,
    x2: 1.463,
    y2: 0.812,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3dce7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbe4f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2.384,
    y1: 0.138,
    x2: 2.37,
    y2: 0.899,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2.381,
    y1: 0.138,
    x2: 2.367,
    y2: 0.898,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2.384,
    y1: 0.138,
    x2: 2.37,
    y2: 0.898,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.769,
    y1: -0.061,
    x2: 0.632,
    y2: 1.37,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccebf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89d6f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1.626,
    y1: 0.326,
    x2: 0.544,
    y2: 1.746,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.229,
    y1: 0.989,
    x2: -0.853,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#154388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d78bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1.229,
    y1: 0.991,
    x2: -0.853,
    y2: 1.298,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1.626,
    y1: 0.326,
    x2: 0.544,
    y2: 1.747,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1.993,
    y1: 0.312,
    x2: 1.484,
    y2: 1.271,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.844,
    y1: 1.115,
    x2: -0.372,
    y2: 1.113,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1.333,
    y1: 1.025,
    x2: 0.319,
    y2: 1.009,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -3.79,
    y1: 0.916,
    x2: -3.778,
    y2: 0.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#184aa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184aa0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.868,
    y1: 0.023,
    x2: 0.613,
    y2: 1.272,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1.995,
    y1: 0.313,
    x2: 1.485,
    y2: 1.271,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -17.05,
    y1: 0.806,
    x2: -17.002,
    y2: 0.264,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#278ecd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239dd7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1.333,
    y1: 1.025,
    x2: 0.323,
    y2: 1.006,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.333,
    y1: 1.028,
    x2: 0.319,
    y2: 1.009,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1.993,
    y1: 0.312,
    x2: 1.484,
    y2: 1.271,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 0.949,
    y1: 0.014,
    x2: 0.381,
    y2: 2.006,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1.143,
    y1: 0.203,
    x2: 1.116,
    y2: 0.931,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1.461,
    y1: 0.095,
    x2: 1.464,
    y2: 0.817,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.868,
    y1: 0.022,
    x2: 0.612,
    y2: 1.272,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.868,
    y1: 0.02,
    x2: 0.612,
    y2: 1.271,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 29.957,
    y1: 0.201,
    x2: 29.93,
    y2: 0.753,
    xlinkHref: "#linear-gradient-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-10840.156 -306.039)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2642417-ai",
    "data-name": "2642417-ai",
    transform: "translate(10876.631 323.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Clip_Group_",
    "data-name": "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(156.654 129.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M2445.259,991l-12.806,7.451L2419.6,991l12.853-7.4Z",
    transform: "translate(-2419.6 -983.6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M2460.006,999.5v250.86l-12.806,7.4V1006.951Z",
    transform: "translate(-2434.347 -992.096)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M2432.453,1006.951v250.814l-12.853-7.4V999.5Z",
    transform: "translate(-2419.6 -992.096)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M2445.259,991v250.86l-12.806,7.4-12.853-7.4V991l12.853-7.4Z",
    transform: "translate(-2419.6 -983.6)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>",
    transform: "translate(144.22 183.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M2410.083,1103.783l-8.568,4.983-8.615-4.983,8.615-4.983Z",
    transform: "translate(-2392.9 -1098.8)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M2419.968,1109.5v167.784l-8.568,4.983V1114.483Z",
    transform: "translate(-2402.785 -1104.517)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M2401.514,1114.483v167.783l-8.615-4.983V1109.5Z",
    transform: "translate(-2392.899 -1104.517)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M2410.083,1103.783v167.784l-8.568,4.983-8.615-4.983V1103.783l8.615-4.983Z",
    transform: "translate(-2392.9 -1098.8)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>",
    transform: "translate(0 318.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_10",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_11",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_12",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M2108.859,1397.051l-12.806,7.4-12.853-7.4,12.853-7.451Z",
    transform: "translate(-2083.2 -1389.6)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M2123.606,1405.6v182.033l-12.806,7.4V1413Z",
    transform: "translate(-2097.947 -1398.149)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M2096.053,1413v182.033l-12.853-7.4V1405.6Z",
    transform: "translate(-2083.2 -1398.149)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M2108.859,1397.051v182.033l-12.806,7.4-12.853-7.4V1397.051l12.853-7.451Z",
    transform: "translate(-2083.2 -1389.6)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_13",
    "data-name": "<Group>",
    transform: "translate(191.812 175.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_14",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_15",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_16",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    d: "M2511.212,1087.1l-8.057,4.657-8.056-4.657,8.056-4.7Z",
    transform: "translate(-2495.1 -1082.4)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_14",
    "data-name": "<Path>",
    d: "M2520.456,1092.5v157.446l-8.056,4.7V1097.157Z",
    transform: "translate(-2504.344 -1087.797)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    d: "M2503.156,1097.157v157.492l-8.056-4.7V1092.5Z",
    transform: "translate(-2495.1 -1087.797)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    d: "M2511.212,1087.1v157.446l-8.057,4.7-8.056-4.7V1087.1l8.056-4.7Z",
    transform: "translate(-2495.1 -1082.4)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_17",
    "data-name": "<Group>",
    transform: "translate(211.79 21.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_18",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_17",
    "data-name": "<Path>",
    d: "M2873.939,751.3v368.49L2706.3,1217.07,2538,1119.79V751.346Z",
    transform: "translate(-2538 -751.3)",
    opacity: 0.6,
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_19",
    "data-name": "<Group>",
    transform: "translate(0 110.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_20",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_21",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_18",
    "data-name": "<Path>",
    d: "M2873.939,1085.28,2706.3,1182.606,2538,1085.28,2706.3,988Z",
    transform: "translate(-2538 -988)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_19",
    "data-name": "<Path>",
    d: "M3067.044,1196.9v243.6L2899.4,1537.822v-243.6Z",
    transform: "translate(-2731.104 -1099.62)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_20",
    "data-name": "<Path>",
    d: "M2706.3,1294.226v243.6l-168.3-97.28V1196.9Z",
    transform: "translate(-2538 -1099.62)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_21",
    "data-name": "<Path>",
    d: "M2899.4,1330.18l167.644-97.28v1.676l-167.644,97.28Z",
    transform: "translate(-2731.104 -1008.63)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_22",
    "data-name": "<Path>",
    d: "M2538,1232.9l168.3,97.28v1.677l-168.3-97.28Z",
    transform: "translate(-2538 -1008.63)",
    fill: "#ff20ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_22",
    "data-name": "<Group>",
    transform: "translate(10.571 77.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_23",
    "data-name": "<Path>",
    d: "M2897.19,917.8l-5.821,47.313-7.031,4.1-7.078-4.1L2870.6,917.8Z",
    transform: "translate(-2726.286 -917.8)",
    opacity: 0.6,
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_24",
    "data-name": "<Path>",
    d: "M2884.9,1014.752l7.031-4.052,7.078,4.052-7.031,4.1Z",
    transform: "translate(-2733.927 -967.439)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_25",
    "data-name": "<Path>",
    d: "M2587.337,1096.4l-5.868,47.313-7.032,4.1-7.078-4.1L2560.7,1096.4Z",
    transform: "translate(-2560.7 -1013.23)",
    opacity: 0.6,
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_26",
    "data-name": "<Path>",
    d: "M2575,1193.3l7.032-4.1,7.078,4.1-7.032,4.1Z",
    transform: "translate(-2568.341 -1062.815)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_27",
    "data-name": "<Path>",
    d: "M3212.336,1096.4l-5.867,47.313-7.032,4.1-7.078-4.1L3185.7,1096.4Z",
    transform: "translate(-2894.651 -1013.23)",
    opacity: 0.6,
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_28",
    "data-name": "<Path>",
    d: "M3200,1193.3l7.032-4.1,7.078,4.1-7.032,4.1Z",
    transform: "translate(-2902.292 -1062.815)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_29",
    "data-name": "<Path>",
    d: "M2897.19,1271.4l-5.821,47.313-7.031,4.1-7.078-4.1L2870.6,1271.4Z",
    transform: "translate(-2726.286 -1106.736)",
    opacity: 0.6,
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_30",
    "data-name": "<Path>",
    d: "M2884.9,1368.3l7.031-4.1,7.078,4.1-7.031,4.1Z",
    transform: "translate(-2733.927 -1156.322)",
    fill: "#a5ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_23",
    "data-name": "<Group>",
    transform: "translate(71.248 60.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_24",
    "data-name": "<Group>",
    transform: "translate(2.701 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_31",
    "data-name": "<Path>",
    d: "M2815.476,1063.8a5.031,5.031,0,0,1,4.47,0l69.386,40.328c1.211.745,1.211,1.863-.046,2.608l-117.257,67.71a4.888,4.888,0,0,1-4.471-.047l-69.339-40.281c-1.258-.745-1.258-1.863,0-2.608Z",
    transform: "translate(-2697.054 -980.033)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M2832.676,1085.18a1.42,1.42,0,0,1-1.071,0l-4.843-2.841c-.28-.14-.28-.419,0-.605l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.844,2.794c.279.186.279.466,0,.605Zm-7.032,4.051a1.008,1.008,0,0,1-1.024,0l-4.843-2.794c-.326-.186-.326-.466,0-.652l4.843-2.794a1.094,1.094,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652Zm-6.985,4.051a1.419,1.419,0,0,1-1.071,0l-4.844-2.841c-.279-.186-.325-.419,0-.605l4.844-2.794a1.094,1.094,0,0,1,1.071,0l4.843,2.794c.28.186.326.419,0,.605Zm27.941,0a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.466,0-.605l4.889-2.84a1.1,1.1,0,0,1,1.071,0l4.843,2.84c.279.14.279.419,0,.605Zm-19.465,2.561-4.843-2.841c-.28-.14-.28-.419,0-.605l4.89-2.841a1.419,1.419,0,0,1,1.071,0l4.843,2.841c.28.186.28.419,0,.605l-4.889,2.841A1.421,1.421,0,0,1,2827.134,1095.844Zm17.323-1.956c.28.186.28.466,0,.605l-4.889,2.841a1.3,1.3,0,0,1-1.024,0l-4.843-2.841c-.326-.14-.326-.419,0-.605l4.843-2.794a1.1,1.1,0,0,1,1.071,0Zm-39.815,7.451a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.279-.186-.279-.466,0-.605l4.89-2.841a1.009,1.009,0,0,1,1.024,0l4.843,2.841c.326.14.326.419,0,.605Zm8.522,2.515-4.843-2.794c-.28-.186-.28-.466,0-.605l4.889-2.841a1.3,1.3,0,0,1,1.025,0l4.843,2.841c.326.14.326.419,0,.605l-4.843,2.794A1.1,1.1,0,0,1,2813.164,1103.853Zm-15.507,1.537a1.42,1.42,0,0,1-1.071,0l-4.843-2.84c-.279-.14-.279-.419,0-.605l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.605Zm22.027-2.794c-.28-.186-.28-.466,0-.605l4.889-2.841a1.009,1.009,0,0,1,1.024,0l4.843,2.841c.326.14.326.419,0,.605l-4.843,2.794a1.1,1.1,0,0,1-1.071,0Zm-13.5-.885a1.418,1.418,0,0,1,1.071,0l4.843,2.84c.28.14.28.419,0,.605l-4.889,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.465,0-.605Zm-15.554,7.73a1.009,1.009,0,0,1-1.024,0l-4.843-2.794c-.326-.186-.326-.466,0-.652l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652Zm22.027-2.841c-.279-.186-.279-.466,0-.605l4.89-2.84a1.42,1.42,0,0,1,1.071,0l4.843,2.84c.28.14.28.419,0,.605l-4.89,2.841a1.419,1.419,0,0,1-1.071,0Zm49.129-.885a1.1,1.1,0,0,1,1.071,0l1.444.838c.28.186.28.466,0,.605l-5.821,3.353a1.1,1.1,0,0,1-1.071,0l-1.444-.838c-.326-.14-.326-.419,0-.605Zm-62.634,0a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652l-4.89,2.794a1.135,1.135,0,0,1-1.025,0l-4.843-2.841c-.326-.14-.326-.419,0-.605Zm17.277,4.331c.28.14.28.419,0,.605l-4.889,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.279-.186-.279-.466,0-.605l4.89-2.841a1.419,1.419,0,0,1,1.071,0Zm-24.308-.233a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.279.186.279.466,0,.605l-4.889,2.841a1.305,1.305,0,0,1-1.025,0l-4.89-2.841c-.28-.14-.28-.419.047-.605Zm27.8,6.892a1.094,1.094,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.465,0-.605l4.889-2.841a1.423,1.423,0,0,1,1.072,0l4.843,2.841c.28.14.28.419,0,.605Zm-43.355.838a1.418,1.418,0,0,1-1.071,0l-4.843-2.84c-.28-.14-.28-.419,0-.606l4.89-2.794a1.008,1.008,0,0,1,1.024,0l4.844,2.794c.326.186.326.466,0,.606Zm8.522-3.679a1.1,1.1,0,0,1,1.071,0l4.843,2.841c.279.14.279.419,0,.605l-4.89,2.794a1.009,1.009,0,0,1-1.025,0l-4.843-2.794c-.326-.186-.326-.466,0-.605Zm21.887,4.1a.358.358,0,0,1,0-.652l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.279.187.279.466,0,.606l-4.89,2.841a1.233,1.233,0,0,1-1.071,0Zm-37.441,3.632a1.094,1.094,0,0,1-1.071,0l-4.843-2.794a.359.359,0,0,1,0-.652l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466-.047.652Zm32.831-3.446c.325.186.325.466,0,.605l-4.843,2.841a1.418,1.418,0,0,1-1.071,0l-4.843-2.841c-.279-.14-.326-.419,0-.605l4.843-2.794a1.242,1.242,0,0,1,1.071-.047Zm-24.262-.233a1.008,1.008,0,0,1,1.024,0l4.843,2.794c.326.186.326.466,0,.652l-4.843,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.358.358,0,0,1,0-.652Zm57.231-.745a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.605l-6.287,3.632a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.326-.466,0-.605Zm-39.955,5.076c.279.186.279.466,0,.605l-4.89,2.794a1.236,1.236,0,0,1-1.071.047l-4.843-2.841c-.279-.14-.279-.419.047-.605l4.843-2.841a1.423,1.423,0,0,1,1.071,0Zm21.048,4.61a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.466.047-.652l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652Zm-45.357-4.89a1.42,1.42,0,0,1,1.071,0l4.843,2.841c.279.139.279.419,0,.605l-4.89,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.466,0-.605Zm-15.507,7.73a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.326-.186-.28-.466,0-.652l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.326.187.326.466,0,.652Zm32.83-3.446c.28.187.28.466,0,.606l-4.889,2.841a1.42,1.42,0,0,1-1.072,0l-4.843-2.841c-.28-.14-.28-.419,0-.606l4.89-2.84a1.42,1.42,0,0,1,1.071,0Zm-24.308,6.007-4.843-2.841c-.326-.14-.326-.419,0-.605l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652l-4.89,2.794A1.3,1.3,0,0,1,2764.081,1132.26Zm-15.507,1.49a1.094,1.094,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.326-.466,0-.652l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.89,2.794c.279.186.279.465-.047.652Zm32.831-3.446c.279.186.279.465,0,.605l-4.89,2.84a1.418,1.418,0,0,1-1.071,0l-4.843-2.84c-.279-.14-.279-.419,0-.605l4.889-2.794a1.1,1.1,0,0,1,1.071,0Zm45.543-8.336a1.418,1.418,0,0,1,1.071,0l4.843,2.84c.279.14.279.419,0,.605l-38.419,22.166a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.359.359,0,0,1,0-.652Zm-69.852,8.056a1.233,1.233,0,0,1,1.071,0l4.843,2.841c.28.14.326.419,0,.605l-4.843,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.326-.466,0-.652Zm6.519,4.936c-.326-.14-.326-.419,0-.606l4.843-2.84a1.419,1.419,0,0,1,1.071,0l4.843,2.84c.28.187.28.466,0,.606l-4.889,2.841a1.3,1.3,0,0,1-1.024,0Zm3.772,3.4c.28.186.28.465-.047.652l-4.843,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.359.359,0,0,1,0-.652l4.89-2.794a1.1,1.1,0,0,1,1.071,0Zm21.049,4.564a1.1,1.1,0,0,1-1.072,0l-4.843-2.794c-.28-.186-.28-.419,0-.605l4.89-2.841a1.422,1.422,0,0,1,1.071,0l4.843,2.841c.28.186.28.419,0,.605Zm-54.95-7.4a1.421,1.421,0,0,1,1.071,0l4.843,2.841c.279.14.279.419,0,.605l-9.313,5.356a1.011,1.011,0,0,1-1.025,0l-4.843-2.794c-.326-.186-.326-.466,0-.652Zm16.019,7.5c-.279-.186-.279-.466.047-.605l4.843-2.841a1.422,1.422,0,0,1,1.071,0l4.843,2.841c.28.14.28.419,0,.605l-4.89,2.794a1.1,1.1,0,0,1-1.071,0Zm52.9-8.149a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.358.358,0,0,1,0-.652l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652ZM2736,1142.132a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.358.358,0,0,1,0,.652l-4.89,2.794a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.358.358,0,0,1,0-.652Zm21.934,4.1c-.28-.14-.28-.419,0-.605l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.279.186.279.466-.047.605l-4.843,2.841a1.232,1.232,0,0,1-1.071,0Zm16.438,4.8a1.1,1.1,0,0,1-1.071,0l-4.843-2.794a.358.358,0,0,1,0-.652l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.8,2.794c.326.186.326.466.047.652Zm-27.009-7.451a1.417,1.417,0,0,1,1.071,0l4.843,2.841c.28.186.28.466,0,.605l-9.267,5.355a1.1,1.1,0,0,1-1.072,0l-4.843-2.794c-.326-.186-.28-.466,0-.605Zm38.93,1.723a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.606l-6.333,3.632a1.009,1.009,0,0,1-1.025,0l-4.843-2.794c-.326-.186-.326-.419,0-.605Zm-20.024,3.446a1.421,1.421,0,0,1,1.071,0l4.843,2.841c.28.186.28.466,0,.605l-14.3,8.242a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.279-.186-.279-.466,0-.605Zm4.564,5.448a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.605l-4.889,2.841a1.419,1.419,0,0,1-1.071,0l-4.843-2.841c-.279-.14-.279-.419,0-.605Zm64.31-62.541a1.417,1.417,0,0,1-1.071,0l-4.843-2.84c-.28-.14-.28-.419,0-.605l9.313-5.356a1.1,1.1,0,0,1,1.071,0l4.844,2.794c.279.186.279.466,0,.605Zm-23.61,5.588a1.421,1.421,0,0,1-1.071,0l-4.843-2.841c-.279-.14-.279-.419,0-.605l4.89-2.841a1.421,1.421,0,0,1,1.071,0l4.843,2.841c.28.186.28.466,0,.605Zm8.475,2.561-4.843-2.841c-.279-.14-.279-.419,0-.605l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.605l-4.889,2.841A1.419,1.419,0,0,1,2820.009,1099.8Zm27.894.652a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.326-.186-.28-.466,0-.606L2852.42,1091a1.1,1.1,0,0,1,1.071,0l4.843,2.794a.359.359,0,0,1,0,.652Zm-21.328-2c-.279-.186-.279-.466,0-.605l4.89-2.841a1.419,1.419,0,0,1,1.071,0l4.844,2.841c.279.14.279.419-.047.605l-4.843,2.794a1.1,1.1,0,0,1-1.071,0Zm14.3,6.054a1.009,1.009,0,0,1-1.025,0l-4.843-2.794c-.326-.186-.28-.466,0-.652l4.889-2.794a1.009,1.009,0,0,1,1.025,0l4.843,2.794c.326.186.28.466,0,.605Zm18.534-9.453a1.418,1.418,0,0,1,1.071,0l4.8,2.794a.358.358,0,0,1,0,.652l-13.877,8.01a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.279-.186-.279-.466.047-.605Zm-25.566,13.5a1.422,1.422,0,0,1-1.071,0l-4.8-2.841c-.326-.14-.326-.419,0-.605l4.843-2.794a1.094,1.094,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.605Zm24.448-4.75a1.1,1.1,0,0,1,1.071,0l1.444.838c.279.186.279.466,0,.605l-5.821,3.353a1.1,1.1,0,0,1-1.071,0l-1.444-.838c-.279-.14-.279-.419,0-.605Zm-4.7,6.52a1.418,1.418,0,0,1,1.071,0l1.4.838c.326.186.326.466.046.652l-5.821,3.353a1.1,1.1,0,0,1-1.071,0l-1.444-.838c-.326-.186-.326-.466,0-.605Zm16.065-9.267a1.1,1.1,0,0,1,1.071,0l1.4.838c.326.186.326.466.047.605l-5.821,3.353a1.1,1.1,0,0,1-1.071,0l-1.444-.838c-.326-.14-.326-.419,0-.605Zm-25.333,9.453a1.1,1.1,0,0,1-1.071,0l-4.8-2.794c-.28-.186-.28-.419,0-.605l4.89-2.794a1.094,1.094,0,0,1,1.071,0l4.8,2.794c.279.14.279.419,0,.605Zm-17.51,2.049a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.466,0-.605l4.889-2.841a1.421,1.421,0,0,1,1.071,0l4.843,2.841c.28.14.28.419-.047.605Zm-43.354.838a1.135,1.135,0,0,1-1.024,0l-4.843-2.841c-.326-.14-.326-.419,0-.606l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466,0,.606Zm47.965-1.63c-.28-.186-.28-.466,0-.605l4.89-2.841a1.42,1.42,0,0,1,1.071,0l4.8,2.794a.358.358,0,0,1,0,.652l-.139.093-4.7,2.7a1.1,1.1,0,0,1-1.071,0Zm-22.166,2.282c.279.186.279.466,0,.605l-4.89,2.841a1.419,1.419,0,0,1-1.071,0l-4.843-2.841c-.28-.14-.28-.419,0-.605l4.889-2.794a1.1,1.1,0,0,1,1.071,0Zm15.181,1.77c-.326-.186-.326-.466,0-.605l4.843-2.841a1.1,1.1,0,0,1,1.071,0l4.844,2.794a.358.358,0,0,1,0,.652l-4.89,2.794a1.1,1.1,0,0,1-1.071,0Zm17.742-2.794a1.1,1.1,0,0,1,1.072,0l4.843,2.841c.326.14.28.419,0,.605l-4.843,2.794a1.306,1.306,0,0,1-1.025,0l-4.843-2.841c-.326-.14-.326-.419,0-.605Zm-18.86,9.639a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.28-.186-.28-.466,0-.605l4.889-2.841a1.1,1.1,0,0,1,1.071,0l4.8,2.841c.326.14.326.419.047.605Zm-23.47-.745a.358.358,0,0,1,0-.652l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.279.186.279.466-.047.652l-4.843,2.794a1.094,1.094,0,0,1-1.071,0Zm-37.487,3.632a1.009,1.009,0,0,1-1.025,0l-4.843-2.794c-.326-.186-.326-.466,0-.605l4.843-2.841a1.423,1.423,0,0,1,1.071,0l4.843,2.841c.28.14.28.419,0,.605Zm30.455.373c-.28-.14-.28-.419,0-.605l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.466-.047.605l-4.843,2.84a1.233,1.233,0,0,1-1.071,0Zm16.438,4.8a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.326-.186-.279-.466,0-.652l4.89-2.794a1.094,1.094,0,0,1,1.071,0l4.8,2.794c.326.186.326.466,0,.652Zm-23.424-.792c-.279-.14-.279-.419,0-.605l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.8,2.794c.326.186.326.419,0,.605l-4.843,2.841a1.42,1.42,0,0,1-1.071,0Zm-7.031,4.051a.358.358,0,0,1,0-.652l4.89-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.28.186.28.465,0,.605l-4.889,2.84a1.094,1.094,0,0,1-1.071,0Zm-37.441,3.632a1.094,1.094,0,0,1-1.071,0l-4.843-2.794a.358.358,0,0,1,0-.652l4.889-2.794a1.009,1.009,0,0,1,1.024,0l4.843,2.841c.326.14.326.419,0,.605Zm53.926,1.164a1.42,1.42,0,0,1-1.071,0l-4.843-2.84c-.326-.186-.326-.419,0-.606l4.843-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.326.186.326.466,0,.606Zm-45.4,1.4-4.843-2.794a.358.358,0,0,1,0-.652l4.889-2.794a1.1,1.1,0,0,1,1.071,0l4.843,2.84c.279.14.279.419,0,.606l-4.89,2.794A1.1,1.1,0,0,1,2749.878,1140.176Zm21.98-2.142c-.326-.186-.326-.419,0-.605l4.843-2.841a1.417,1.417,0,0,1,1.071,0l4.843,2.841c.326.186.28.419,0,.605l-4.89,2.794a1.1,1.1,0,0,1-1.071,0Zm-33.808,3.4c-.279-.187-.279-.466,0-.605l4.889-2.841a1.42,1.42,0,0,1,1.072,0l4.843,2.841c.28.14.28.419,0,.605l-4.89,2.794a1.1,1.1,0,0,1-1.071,0Zm32.737,3.492a1.1,1.1,0,0,1-1.071,0l-4.843-2.794c-.279-.186-.279-.466,0-.605l4.89-2.841a1.234,1.234,0,0,1,1.071,0l4.8,2.794c.326.186.326.466,0,.652Zm4.656-.838c-.326-.186-.279-.466,0-.605l4.843-2.841a1.421,1.421,0,0,1,1.071,0l4.843,2.841c.326.14.326.419,0,.605l-4.843,2.841a1.229,1.229,0,0,1-1.071-.047Zm-19.7,2.7a1.1,1.1,0,0,1,1.071,0l4.844,2.794c.279.186.279.466,0,.605l-10.758,6.194a1.008,1.008,0,0,1-1.024,0l-4.843-2.794c-.326-.186-.28-.419,0-.605Zm22.073,3.353a1.42,1.42,0,0,1,1.071,0l4.843,2.84c.279.187.279.466,0,.606l-4.89,2.794a1.23,1.23,0,0,1-1.071.047l-4.843-2.841c-.28-.14-.28-.419.046-.606Zm41.072-13.784a2.677,2.677,0,0,1,2.236,0l14.576,8.475a.7.7,0,0,1,0,1.3l-26.171,15.042a2.574,2.574,0,0,1-2.189,0l-14.576-8.475a.7.7,0,0,1,0-1.3Zm-55.136,21.887a1.1,1.1,0,0,1,1.071,0l4.843,2.794c.326.186.28.465,0,.605l-4.843,2.841a1.418,1.418,0,0,1-1.071,0l-4.843-2.841c-.326-.14-.326-.419,0-.605Z",
    transform: "translate(-2711.32 -988.328)",
    fill: "#193164",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M2815.175,884.976c1.816-1.071,3.353-.186,3.353,1.909l.233,81.54-121.728,70.317-.232-81.54a7.48,7.48,0,0,1,3.306-5.821Z",
    transform: "translate(-2696.8 -884.52)",
    fill: "#1a6cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_32",
    "data-name": "<Path>",
    d: "M2890.276,1158.923a1.645,1.645,0,0,1-.931,1.3l-117.258,67.71a5.032,5.032,0,0,1-4.471,0l-69.386-40.328a.041.041,0,0,1-.046-.047c-.047,0-.094-.046-.14-.093a1.538,1.538,0,0,1-.233-.186h-.047a1.578,1.578,0,0,1-.186-.233l-.047-.047v-.047l-.093-.093a.188.188,0,0,1-.047-.14v-.047a.041.041,0,0,1-.046-.046v-.093a.41.41,0,0,1-.047-.186v-5.169a1.026,1.026,0,0,0,.047.326v.046a1.16,1.16,0,0,0,.139.28l.046.047a1.194,1.194,0,0,0,.28.279l.186.186c.093.046.14.093.233.14l69.34,40.281a4.886,4.886,0,0,0,4.47.047L2889.3,1155.1a1.548,1.548,0,0,0,.931-1.3Z",
    transform: "translate(-2697.066 -1028.402)",
    fill: "#1a6cbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_25",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_26",
    "data-name": "<Group>",
    transform: "translate(8.289 9.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_33",
    "data-name": "<Path>",
    d: "M2819.352,902.1l.186,72.553L2708.986,1038.5l-.186-72.6Z",
    transform: "translate(-2708.8 -902.1)",
    fill: "#102465"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_34",
    "data-name": "<Path>",
    d: "M2708.8,968.226V965.9l110.552-63.8v2.282Z",
    transform: "translate(-2700.511 -892.321)",
    fill: "#00154f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_35",
    "data-name": "<Path>",
    d: "M2812.681,882.869a2.156,2.156,0,0,0-.606.279l-115.068,66.406q-.326.233-.605.466a.731.731,0,0,1-.186.14,2.7,2.7,0,0,0-.419.419.544.544,0,0,0-.14.093q-.233.28-.465.605l-.047.047a4.883,4.883,0,0,0-.466.745h-.047q-.186.419-.373.792h0a4.957,4.957,0,0,0-.28.792.134.134,0,0,0-.047.093c-.062.248-.124.5-.186.745v.093a6.345,6.345,0,0,0-.047.792l.232,81.54-.791-.512a3.91,3.91,0,0,1-1.909-3.353l-.233-79.3a4.61,4.61,0,0,1,.047-.652V953a.189.189,0,0,1,.047-.14v-.233l.093-.373a.354.354,0,0,0,.047-.14l.047-.046a.414.414,0,0,1,.046-.186l.093-.279a1.029,1.029,0,0,1,.14-.326h0a1.178,1.178,0,0,1,.14-.279,1.149,1.149,0,0,1,.14-.279,1.811,1.811,0,0,1,.093-.233l.047-.047h0l.186-.279a3.044,3.044,0,0,0,.186-.326l.093-.093a.041.041,0,0,1,.047-.047.549.549,0,0,1,.093-.14,3.089,3.089,0,0,1,.28-.326.515.515,0,0,1,.093-.14l.14-.14a.56.56,0,0,0,.093-.14,1.235,1.235,0,0,0,.326-.233l.186-.186a4.209,4.209,0,0,1,.605-.419l115.069-66.406a3.268,3.268,0,0,1,.466-.233.19.19,0,0,1,.139-.047.135.135,0,0,1,.094-.047.358.358,0,0,1,.14-.046q.14-.047.326-.093h.652l.047.046h.14l.186.093a.19.19,0,0,1,.14.047l.046.047,2.7,1.583a1.448,1.448,0,0,0-.512-.186h0a1.681,1.681,0,0,0-.559,0h-.047a1.759,1.759,0,0,0-.559.093.133.133,0,0,1-.093.047Z",
    transform: "translate(-2691 -881.1)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_27",
    "data-name": "<Group>",
    transform: "translate(237.094 161.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_28",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_29",
    "data-name": "<Group>",
    transform: "translate(0 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_36",
    "data-name": "<Path>",
    d: "M3063.791,1226.08a15.007,15.007,0,0,1-13.784,0c-3.819-2.189-3.819-5.775-.047-7.963a15.288,15.288,0,0,1,13.784,0C3067.563,1220.305,3067.563,1223.891,3063.791,1226.08Z",
    transform: "translate(-3047.137 -1161.936)",
    fill: "#1a9bdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_30",
    "data-name": "<Group>",
    transform: "translate(2.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_31",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_37",
    "data-name": "<Path>",
    d: "M3056.431,1229.612s-3.446-2.235-3.539-2.794.745-1.118,1.3-1.118l3.027.233.792.885S3059.411,1230.17,3056.431,1229.612Z",
    transform: "translate(-3052.885 -1166.865)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_38",
    "data-name": "<Path>",
    d: "M3072.63,1223.562s-3.446-2.235-3.539-2.794c-.093-.512.745-1.118,1.3-1.071.605,0,3.027.186,3.027.186l.792.885S3075.611,1224.121,3072.63,1223.562Z",
    transform: "translate(-3061.54 -1163.656)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_39",
    "data-name": "<Path>",
    d: "M3070.287,1162.5l-1.816,27.149a2.913,2.913,0,0,1-3.493.419s-.373-22.911-.466-22.352c-.047.559-3.259,25.053-3.259,25.053a3.314,3.314,0,0,1-3.353.093l.092-28.36Z",
    transform: "translate(-3055.565 -1133.096)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_40",
    "data-name": "<Path>",
    d: "M3083.221,1131.1c.28,1.118,1.583,5.449,1.583,6.147.094,3.027-3.818,5.076-3.818,5.076l-.187-4.983C3081.824,1136.269,3081.871,1131.845,3083.221,1131.1Z",
    transform: "translate(-3067.8 -1116.318)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_41",
    "data-name": "<Path>",
    d: "M3065.242,1118.96a10.845,10.845,0,0,1,2.84.14,29.82,29.82,0,0,1,1.49,6.939c.419,3.912.512,12.853.512,12.853s-1.071,1.723-5.169,2.794c-4.983,1.3-7.4-.466-7.4-.466l-.512-19.372a8.326,8.326,0,0,1,3.306-1.816Z",
    transform: "translate(-3055.083 -1109.813)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_42",
    "data-name": "<Path>",
    d: "M3067.561,1108.877c-2.468.605-3.26-.14-3.26-.14l-.14-1.257c-1.723.046-1.63-.559-1.723-1.77s-.047-4.424,0-5.356.838-1.211,2.748-.838c1.909.326,2.1,3.911,2.1,3.911.186-.326,1.164-.978,1.3.047a.889.889,0,0,1-.792,1.118l-.093,3.772Z",
    transform: "translate(-3057.96 -1099.357)",
    fill: "#ffc6a0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_43",
    "data-name": "<Path>",
    d: "M3064.1,1119.365c.047-.745.14-1.164,1.863-1.35s3.12-.652,3.306,0c.14.652-.186,1.071-1.909,1.211S3064.1,1119.365,3064.1,1119.365Z",
    transform: "translate(-3056.2 -1108.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_44",
    "data-name": "<Path>",
    d: "M3065.065,1102.422c.047-.28,0-.652-.326-.745a.6.6,0,0,0-.652.279,5.672,5.672,0,0,0-.652,1.3q-.233-.233-.512-.466v-.326a2.53,2.53,0,0,0,0-.838c-.14-.559-.745-.652-1.072-1.117a1.78,1.78,0,0,1,.186-1.956,2.916,2.916,0,0,1,1.677-1.164c2.236-.745,5.635.885,4.983,3.679-.372,1.583-.931,3.12-1.35,4.657-.047.233-.512.326-.745.233a1.21,1.21,0,0,1-.512-.326,8.947,8.947,0,0,1-1.816-2.375A3.465,3.465,0,0,0,3065.065,1102.422Z",
    transform: "translate(-3054.884 -1097.213)",
    fill: "#103450"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_45",
    "data-name": "<Path>",
    d: "M3056.551,1163.349a7.2,7.2,0,0,1-.372-.885c-.14-.745.512-1.583,1.258-1.118a2.2,2.2,0,0,1,.465.466,1.07,1.07,0,0,1,.373.838c-.093.279-.373.466-.373.7,0,.14.093.28.093.419.047.14-.047.28-.093.419a3.313,3.313,0,0,0-.233.466c-.14.233-.326.512-.605.512a.459.459,0,0,1-.419-.466A13.073,13.073,0,0,0,3056.551,1163.349Z",
    transform: "translate(-3051.958 -1131.409)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_46",
    "data-name": "<Path>",
    d: "M3052.026,1146.051s-4.238-6.473-4.331-7.916c-.139-1.444,3.493-9.034,3.493-9.034l2.747,3.074-3.12,5.635,1.77,6.287Z",
    transform: "translate(-3047.433 -1114.251)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_47",
    "data-name": "<Path>",
    d: "M3050.1,1131.114c1.165-2.887,2.422-5.542,3.213-5.914a9.361,9.361,0,0,1,1.723,5.961,8.947,8.947,0,0,1-.7,2.375q-2.142-1.118-4.238-2.422Z",
    transform: "translate(-3048.72 -1112.167)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_48",
    "data-name": "<Path>",
    d: "M3081.126,1127.356l-.326-8.056c.745.233,2.142,3.306,3.213,6.38C3083.035,1126.238,3082.057,1126.751,3081.126,1127.356Z",
    transform: "translate(-3065.124 -1109.014)",
    fill: "#fdf7fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_32",
    "data-name": "<Group>",
    transform: "translate(90.202 94.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_33",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_34",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_49",
    "data-name": "<Path>",
    d: "M2738.266,1044.461a7.3,7.3,0,0,1-3.26,5.681c-1.816,1.071-3.306.186-3.306-1.863a7.25,7.25,0,0,1,3.26-5.681C2736.776,1041.574,2738.266,1042.412,2738.266,1044.461Z",
    transform: "translate(-2731.7 -1001.099)",
    fill: "#00edf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_50",
    "data-name": "<Path>",
    d: "M2785.755,996.8v.14a1.4,1.4,0,0,1-.7,1.211l-32.458,18.72c-.373.233-.7.047-.7-.419v-.093a1.494,1.494,0,0,1,.7-1.211l32.458-18.767C2785.476,996.152,2785.755,996.338,2785.755,996.8Z",
    transform: "translate(-2742.493 -976.586)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_51",
    "data-name": "<Path>",
    d: "M2761.353,1036.427v.14a1.645,1.645,0,0,1-.7,1.211l-8.01,4.61c-.419.233-.745.047-.745-.373v-.14a1.643,1.643,0,0,1,.7-1.211l8.056-4.657C2761.027,1035.822,2761.353,1035.962,2761.353,1036.427Z",
    transform: "translate(-2742.493 -997.769)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_52",
    "data-name": "<Path>",
    d: "M2798.411,1006.2a1.745,1.745,0,0,1-.745,1.351l-21.422,12.34c-.419.233-.745.047-.745-.466a1.658,1.658,0,0,1,.745-1.3l21.422-12.34A.456.456,0,0,1,2798.411,1006.2Z",
    transform: "translate(-2755.103 -981.609)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_53",
    "data-name": "<Path>",
    d: "M2757.821,1050.3a1.59,1.59,0,0,1-.745,1.3l-4.331,2.515c-.419.233-.745.046-.745-.419a1.589,1.589,0,0,1,.745-1.3l4.331-2.515C2757.495,1049.652,2757.821,1049.838,2757.821,1050.3Z",
    transform: "translate(-2742.546 -1005.172)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_54",
    "data-name": "<Path>",
    d: "M2738.365,1081.209a7.166,7.166,0,0,1-3.26,5.635c-1.816,1.071-3.306.233-3.306-1.863a7.25,7.25,0,0,1,3.259-5.681C2736.875,1078.275,2738.365,1079.113,2738.365,1081.209Z",
    transform: "translate(-2731.753 -1020.71)",
    fill: "#00edf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_55",
    "data-name": "<Path>",
    d: "M2785.9,1033.5v.14a1.645,1.645,0,0,1-.7,1.211l-32.5,18.72c-.372.233-.7.047-.7-.373v-.14a1.565,1.565,0,0,1,.7-1.211l32.458-18.767C2785.575,1032.852,2785.854,1033.038,2785.9,1033.5Z",
    transform: "translate(-2742.546 -996.196)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_56",
    "data-name": "<Path>",
    d: "M2761.453,1073.146v.14a1.644,1.644,0,0,1-.7,1.211l-8.009,4.61c-.419.233-.745.047-.745-.373v-.14a1.566,1.566,0,0,1,.7-1.211l8.056-4.61C2761.127,1072.54,2761.453,1072.68,2761.453,1073.146Z",
    transform: "translate(-2742.546 -1017.396)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_57",
    "data-name": "<Path>",
    d: "M2798.511,1042.9a1.589,1.589,0,0,1-.745,1.3l-21.421,12.387c-.419.233-.745.047-.745-.466a1.733,1.733,0,0,1,.745-1.3l21.421-12.34C2798.185,1042.252,2798.511,1042.438,2798.511,1042.9Z",
    transform: "translate(-2755.156 -1001.218)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_58",
    "data-name": "<Path>",
    d: "M2757.921,1087a1.589,1.589,0,0,1-.745,1.3l-4.331,2.515c-.419.233-.745.047-.745-.419a1.658,1.658,0,0,1,.745-1.3l4.331-2.515C2757.595,1086.352,2757.921,1086.539,2757.921,1087Z",
    transform: "translate(-2742.6 -1024.782)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_59",
    "data-name": "<Path>",
    d: "M2738.466,1117.928a7.165,7.165,0,0,1-3.26,5.635c-1.816,1.071-3.306.233-3.306-1.863a7.1,7.1,0,0,1,3.26-5.635C2736.975,1114.994,2738.466,1115.832,2738.466,1117.928Z",
    transform: "translate(-2731.807 -1040.338)",
    fill: "#00edf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_60",
    "data-name": "<Path>",
    d: "M2786,1070.236v.14a1.643,1.643,0,0,1-.7,1.211l-32.5,18.72c-.373.233-.7.046-.7-.373v-.14a1.566,1.566,0,0,1,.7-1.211l32.457-18.767c.419-.186.745,0,.745.419Z",
    transform: "translate(-2742.6 -1015.838)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_61",
    "data-name": "<Path>",
    d: "M2761.553,1109.856v.14a1.565,1.565,0,0,1-.7,1.211l-8.009,4.657c-.419.186-.7.047-.745-.419v-.14a1.566,1.566,0,0,1,.745-1.211l8.009-4.61C2761.227,1109.251,2761.553,1109.437,2761.553,1109.856Z",
    transform: "translate(-2742.6 -1037.017)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_62",
    "data-name": "<Path>",
    d: "M2798.611,1079.652a1.66,1.66,0,0,1-.745,1.3l-21.421,12.341c-.419.233-.745.047-.745-.419a1.743,1.743,0,0,1,.745-1.35l21.421-12.34C2798.285,1078.953,2798.611,1079.14,2798.611,1079.652Z",
    transform: "translate(-2755.21 -1020.83)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_63",
    "data-name": "<Path>",
    d: "M2758.021,1123.752a1.732,1.732,0,0,1-.745,1.3l-4.331,2.468c-.419.233-.745.047-.745-.419a1.657,1.657,0,0,1,.745-1.3l4.331-2.515C2757.695,1123.053,2758.021,1123.24,2758.021,1123.752Z",
    transform: "translate(-2742.654 -1044.393)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_64",
    "data-name": "<Path>",
    d: "M2906.312,967.775l-6.1,3.493c-.047-8.429-6.007-11.875-13.365-7.637l-.047-6.985C2897.557,950.452,2906.265,955.435,2906.312,967.775Z",
    transform: "translate(-2814.573 -953.984)",
    fill: "#00edf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_65",
    "data-name": "<Path>",
    d: "M2864.671,966.685c-7.358,4.284-13.318,14.576-13.271,23.051,0,4.238,1.49,7.171,3.911,8.569l-4.284,7.4c-3.539-2-5.728-6.333-5.728-12.48-.047-12.294,8.615-27.335,19.326-33.529Z",
    transform: "translate(-2792.398 -957.038)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M2871.337,1017.129c-5.355,3.074-10.2,3.4-13.738,1.35l4.284-7.4c2.421,1.35,5.774,1.164,9.453-.978,7.357-4.238,13.318-14.529,13.272-23l6.1-3.493C2890.709,995.894,2882.048,1010.935,2871.337,1017.129Z",
    transform: "translate(-2798.971 -969.808)",
    fill: "#ff20ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_66",
    "data-name": "<Path>",
    d: "M2783.595,1107v.093a1.528,1.528,0,0,1-.7,1.257l-35.3,20.35c-.419.233-.7.047-.7-.373v-.14a1.449,1.449,0,0,1,.7-1.211l35.3-20.4c.372-.233.7-.046.7.419Z",
    transform: "translate(-2739.821 -1035.469)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_67",
    "data-name": "<Path>",
    d: "M2734.747,1157.7v.093a1.39,1.39,0,0,1-.7,1.211l-1.35.792c-.372.233-.7.047-.7-.373v-.14a1.567,1.567,0,0,1,.7-1.211l1.35-.792c.373-.233.7-.046.7.419Z",
    transform: "translate(-2731.86 -1062.559)",
    fill: "#ff20ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_68",
    "data-name": "<Path>",
    d: "M2884.442,1048.756v.14a1.568,1.568,0,0,1-.7,1.211l-35.345,20.4c-.372.233-.7.047-.7-.419v-.093a1.5,1.5,0,0,1,.7-1.211l35.345-20.4C2884.116,1048.151,2884.442,1048.337,2884.442,1048.756Z",
    transform: "translate(-2793.681 -1004.37)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_69",
    "data-name": "<Path>",
    d: "M2835.647,1099.456v.14a1.566,1.566,0,0,1-.7,1.211l-1.35.792c-.419.233-.7.047-.7-.419v-.14a1.512,1.512,0,0,1,.7-1.211l1.35-.745C2835.322,1098.851,2835.647,1099.037,2835.647,1099.456Z",
    transform: "translate(-2785.773 -1031.46)",
    fill: "#ff20ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_35",
    "data-name": "<Group>",
    transform: "translate(56.673 47.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_36",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_37",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    d: "M2711.623,853.588l.093,34.553a2.615,2.615,0,0,1-1.211,2.1l-49.455,28.592c-.7.373-1.258.047-1.258-.7l-.093-34.6a2.818,2.818,0,0,1,1.21-2.1l49.5-28.546c.652-.419,1.211-.093,1.211.7Zm-16.951,19.7a5.734,5.734,0,0,0-2.608,4.471,2.275,2.275,0,0,0,.466,1.49l-5.961,12.713a1.886,1.886,0,0,0-.838.326,4.248,4.248,0,0,0-1.117.931l-5.542-3.4a4.726,4.726,0,0,0,.28-1.583c0-1.63-1.164-2.282-2.608-1.49a5.818,5.818,0,0,0-2.608,4.517,2.2,2.2,0,0,0,.326,1.211l-5.541,9.779a2.17,2.17,0,0,0-1.118.373,5.745,5.745,0,0,0-2.608,4.517c0,1.63,1.211,2.328,2.655,1.49a5.645,5.645,0,0,0,2.561-4.517,2.215,2.215,0,0,0-.28-1.211l5.5-9.779a2.13,2.13,0,0,0,1.117-.373,5.388,5.388,0,0,0,1.165-.931l5.541,3.4a4.8,4.8,0,0,0-.325,1.537c0,1.677,1.211,2.328,2.654,1.49a5.5,5.5,0,0,0,2.561-4.47,1.861,1.861,0,0,0-.466-1.444l5.96-12.76a2.228,2.228,0,0,0,.839-.279,5.818,5.818,0,0,0,2.608-4.517v-.419l4.471-5.122a1.821,1.821,0,0,0,1.863-.14,5.818,5.818,0,0,0,2.608-4.517c0-1.676-1.164-2.328-2.608-1.49a5.745,5.745,0,0,0-2.608,4.517,1.523,1.523,0,0,0,.047.373l-4.517,5.122A1.842,1.842,0,0,0,2694.672,873.286Z",
    transform: "translate(-2659.7 -852.706)",
    fill: "#00edf9",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_70",
    "data-name": "<Path>",
    d: "M2712.526,876.072a5.818,5.818,0,0,1-2.608,4.517,1.821,1.821,0,0,1-1.863.14l-4.47,5.122v.419a5.817,5.817,0,0,1-2.608,4.517,2.226,2.226,0,0,1-.839.279l-5.961,12.76a1.859,1.859,0,0,1,.466,1.444,5.5,5.5,0,0,1-2.561,4.471c-1.444.838-2.654.186-2.654-1.49a4.8,4.8,0,0,1,.326-1.537l-5.541-3.4a5.388,5.388,0,0,1-1.164.931,2.132,2.132,0,0,1-1.118.372l-5.495,9.779a2.221,2.221,0,0,1,.279,1.211,5.645,5.645,0,0,1-2.561,4.517c-1.444.838-2.655.14-2.655-1.49a5.746,5.746,0,0,1,2.608-4.517,2.168,2.168,0,0,1,1.117-.372l5.542-9.779a2.2,2.2,0,0,1-.326-1.211,5.818,5.818,0,0,1,2.608-4.517c1.444-.792,2.608-.14,2.608,1.49a4.731,4.731,0,0,1-.279,1.583l5.542,3.4a4.256,4.256,0,0,1,1.117-.931,1.887,1.887,0,0,1,.838-.326l5.961-12.713a2.275,2.275,0,0,1-.466-1.49,5.733,5.733,0,0,1,2.608-4.47,1.842,1.842,0,0,1,1.863-.186l4.517-5.123a1.532,1.532,0,0,1-.047-.372,5.746,5.746,0,0,1,2.608-4.517C2711.362,873.743,2712.526,874.4,2712.526,876.072Z",
    transform: "translate(-2666.004 -864.2)",
    fill: "#a5ffff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_38",
    "data-name": "<Group>",
    transform: "translate(31.247 119.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_39",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_40",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_5",
    "data-name": "<Compound Path>",
    d: "M2636.114,1008.076l.046,14.25a2.031,2.031,0,0,1-.885,1.537l-29.244,16.857c-.512.279-.885.047-.885-.512l-.047-14.2a1.906,1.906,0,0,1,.885-1.537l29.245-16.9A.543.543,0,0,1,2636.114,1008.076Zm-17.23,22.213a.857.857,0,0,0,.373-.652c0-.233-.187-.373-.373-.233l-1.677.931a1.042,1.042,0,0,0-.373.7.242.242,0,0,0,.373.233Zm9.36-8.568a.743.743,0,0,0,.373-.652c0-.233-.14-.373-.373-.233l-14.3,8.242a.938.938,0,0,0-.419.7c0,.233.186.326.419.233Zm-6.287.466a.944.944,0,0,0,.373-.652c0-.28-.186-.373-.373-.233l-8.056,4.61a1.041,1.041,0,0,0-.373.7.242.242,0,0,0,.373.233Zm5.635-6.38a.95.95,0,0,0,.373-.7.242.242,0,0,0-.373-.233l-13.644,7.917a.788.788,0,0,0-.419.652.257.257,0,0,0,.419.233Zm5.355.046a.82.82,0,0,0,.373-.7c0-.233-.14-.326-.373-.233l-6.566,3.818a.856.856,0,0,0-.372.652c0,.233.186.373.372.233Zm-8.289,4.8a.821.821,0,0,0,.373-.7c0-.233-.14-.326-.373-.186l-1.025.559a.951.951,0,0,0-.372.7.217.217,0,0,0,.372.186Zm8.335-7.917a.943.943,0,0,0,.373-.652c0-.279-.187-.373-.373-.233l-3.678,2.1a.82.82,0,0,0-.373.7c0,.233.139.326.373.186Zm-22.911,13.132c0-.745-.512-1.025-1.164-.652a2.344,2.344,0,0,0-1.117,1.956c0,.745.512,1.024,1.117.652A2.375,2.375,0,0,0,2610.083,1025.865Zm5.588,6.333a.951.951,0,0,0,.373-.7.217.217,0,0,0-.373-.186l-1.677.931a.952.952,0,0,0-.373.7.217.217,0,0,0,.373.186Z",
    transform: "translate(-2605.1 -1007.446)",
    fill: "#00edf9",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_71",
    "data-name": "<Path>",
    d: "M2637.536,1023.759a.855.855,0,0,1-.373.652l-13.644,7.87c-.233.14-.419.047-.419-.186a.865.865,0,0,1,.419-.7l13.644-7.87C2637.35,1023.386,2637.536,1023.48,2637.536,1023.759Z",
    transform: "translate(-2614.718 -1016.004)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_72",
    "data-name": "<Path>",
    d: "M2632,1037.459a.789.789,0,0,1-.419.652l-8.009,4.657c-.233.14-.373,0-.373-.233a.743.743,0,0,1,.373-.652l8.009-4.657C2631.815,1037.087,2632,1037.18,2632,1037.459Z",
    transform: "translate(-2614.771 -1023.324)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_73",
    "data-name": "<Path>",
    d: "M2638.288,1036.411a.865.865,0,0,1-.419.7l-14.3,8.243a.217.217,0,0,1-.373-.186.821.821,0,0,1,.373-.7l14.3-8.242C2638.1,1036.085,2638.288,1036.178,2638.288,1036.411Z",
    transform: "translate(-2614.771 -1022.788)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_74",
    "data-name": "<Path>",
    d: "M2625.621,1058.859a.856.856,0,0,1-.372.652l-1.677.978a.242.242,0,0,1-.373-.233,1.041,1.041,0,0,1,.373-.7l1.677-.932C2625.435,1058.487,2625.621,1058.58,2625.621,1058.859Z",
    transform: "translate(-2614.771 -1034.758)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_75",
    "data-name": "<Path>",
    d: "M2645.77,1034.159a.8.8,0,0,1-.373.652l-1.024.606a.242.242,0,0,1-.373-.233.949.949,0,0,1,.373-.7l1.024-.559c.186-.14.373-.047.373.233Z",
    transform: "translate(-2625.885 -1021.561)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_76",
    "data-name": "<Path>",
    d: "M2657.258,1023.859a.857.857,0,0,1-.419.652l-6.52,3.772c-.233.14-.419.047-.419-.186a.949.949,0,0,1,.372-.7l6.566-3.772C2657.072,1023.486,2657.258,1023.58,2657.258,1023.859Z",
    transform: "translate(-2629.038 -1016.057)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_77",
    "data-name": "<Path>",
    d: "M2660.524,1017.092a.822.822,0,0,1-.373.7l-3.679,2.1c-.187.14-.373.047-.373-.233a.942.942,0,0,1,.373-.652l3.679-2.142C2660.384,1016.766,2660.524,1016.859,2660.524,1017.092Z",
    transform: "translate(-2632.35 -1012.456)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_78",
    "data-name": "<Path>",
    d: "M2612.982,1046.073a2.522,2.522,0,0,1-1.164,2c-.6.373-1.117.047-1.117-.652a2.6,2.6,0,0,1,1.117-2C2612.469,1045.049,2612.982,1045.375,2612.982,1046.073Z",
    transform: "translate(-2608.092 -1027.654)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_79",
    "data-name": "<Path>",
    d: "M2632.721,1054.769a.856.856,0,0,1-.373.652l-1.676.978a.242.242,0,0,1-.372-.233,1.041,1.041,0,0,1,.372-.7l1.676-.931C2632.535,1054.4,2632.721,1054.536,2632.721,1054.769Z",
    transform: "translate(-2618.565 -1032.578)",
    fill: "#a5ffff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_41",
    "data-name": "<Group>",
    transform: "translate(81.726 300.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_42",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_80",
    "data-name": "<Path>",
    d: "M2713.5,1431.733V1396.9l65.8,38.046v34.833Z",
    transform: "translate(-2713.5 -1396.9)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_81",
    "data-name": "<Path>",
    d: "M2743.583,1414.423l-30.083,17.416v-34.646l.14-.093Z",
    transform: "translate(-2713.5 -1397.007)",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_43",
    "data-name": "<Group>",
    transform: "translate(0 51.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_82",
    "data-name": "<Path>",
    d: "M2713.5,1542.986V1508.2l65.8,38.046v34.833Z",
    transform: "translate(-2713.5 -1508.2)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_83",
    "data-name": "<Path>",
    d: "M2743.583,1525.723l-30.083,17.37v-34.6l.14-.093Z",
    transform: "translate(-2713.5 -1508.307)",
    fill: "url(#linear-gradient-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_44",
    "data-name": "<Group>",
    transform: "translate(0 103.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_84",
    "data-name": "<Path>",
    d: "M2713.5,1654.286V1619.5l65.8,38.046v34.786Z",
    transform: "translate(-2713.5 -1619.5)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_85",
    "data-name": "<Path>",
    d: "M2743.583,1637.023l-30.083,17.37v-34.6l.14-.093Z",
    transform: "translate(-2713.5 -1619.607)",
    fill: "url(#linear-gradient-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_45",
    "data-name": "<Group>",
    transform: "translate(210.952 35.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_46",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_47",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_86",
    "data-name": "<Path>",
    d: "M3121.7,989.362l-47.5-27.382.093-28.08,47.453,27.429Z",
    transform: "translate(-3035.456 -883.933)",
    fill: "#a5ffff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_87",
    "data-name": "<Path>",
    d: "M3143.631,1051.528l-29.431-17,.046-10.431,29.431,17Z",
    transform: "translate(-3056.829 -932.129)",
    fill: "#a5ffff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_88",
    "data-name": "<Path>",
    d: "M3150.28,944.747l-9.08-5.262.047-10.385,9.08,5.216Z",
    transform: "translate(-3071.255 -881.368)",
    fill: "#a5ffff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_6",
    "data-name": "<Compound Path>",
    d: "M3064.584,886.533,3013.5,857.055l.093-30.455,51.085,29.477Zm-3.213-8.1s-2.841-12.34-7.73-15.181c-3.958-2.282-5.682,3.493-8.149,2.1-2.421-1.4-2.421-8.475-4.75-9.826s-2.561,5.122-6.333,2.934-4.7-13.086-9.5-15.88c-4.843-2.747-8.15,10.059-8.15,10.059Z",
    transform: "translate(-3003.022 -826.6)",
    fill: "#a5ffff",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_89",
    "data-name": "<Path>",
    d: "M3038.149,876.336c3.772,2.189,4-4.284,6.333-2.934,2.328,1.3,2.328,8.429,4.75,9.826,2.468,1.4,4.191-4.377,8.149-2.1,4.89,2.794,7.73,15.181,7.73,15.181l-44.612-25.8s3.353-12.806,8.149-10.059C3033.446,863.251,3034.377,874.147,3038.149,876.336Z",
    transform: "translate(-3006.762 -844.484)",
    fill: "#b4ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_7",
    "data-name": "<Compound Path>",
    d: "M3039.837,950.628c0,7.358-5.216,10.338-11.642,6.613-6.426-3.679-11.6-12.666-11.6-20.071.047-7.358,5.262-10.338,11.688-6.613C3034.668,934.236,3039.884,943.223,3039.837,950.628Zm-10.85-3.819,3.678-.326-3.678-4.564-3.679-4.564v4.89l-.047,4.89Z",
    transform: "translate(-3004.678 -881.288)",
    fill: "#a5ffff",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_90",
    "data-name": "<Path>",
    d: "M3038.925,951.564l3.679,4.564-3.679.326-3.724.326.046-4.89V947Z",
    transform: "translate(-3014.617 -890.932)",
    fill: "#b8ffff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_8",
    "data-name": "<Compound Path>",
    d: "M3020.1,998.9l-7.218-12.48-11.036,6.287-5.449-9.453-5.4,3.074v3.213l.047-21.142,29.1,16.811ZM3004.6,985.351a5.817,5.817,0,0,0-2.608-4.517c-1.444-.792-2.608-.14-2.608,1.49a5.577,5.577,0,0,0,2.561,4.517C3003.386,987.679,3004.551,986.98,3004.6,985.351Z",
    transform: "translate(-2991 -902.367)",
    fill: "#a5ffff",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_91",
    "data-name": "<Path>",
    d: "M3020.1,1015.947v7.451l-29.1-16.811v-3.213l5.4-3.074,5.449,9.453,11.036-6.287Z",
    transform: "translate(-2991 -919.412)",
    fill: "#b4ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_92",
    "data-name": "<Path>",
    d: "M3014.216,999.233c0,1.676-1.211,2.328-2.655,1.49a5.811,5.811,0,0,1-2.561-4.471c0-1.677,1.164-2.328,2.607-1.537A5.818,5.818,0,0,1,3014.216,999.233Z",
    transform: "translate(-3000.617 -916.249)",
    fill: "#b4ffff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_48",
    "data-name": "<Group>",
    transform: "translate(40.467 120.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_49",
    "data-name": "<Group>",
    transform: "translate(0 85.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_50",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_51",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_93",
    "data-name": "<Path>",
    d: "M2263.561,1175.5l-46.614,27.056L2170.1,1175.5l46.847-27.1Z",
    transform: "translate(-2170.1 -1148.4)",
    fill: "url(#linear-gradient-33)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_94",
    "data-name": "<Path>",
    d: "M2317.314,1206.6v246.064L2270.7,1479.72V1233.656Z",
    transform: "translate(-2223.852 -1179.497)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_95",
    "data-name": "<Path>",
    d: "M2216.947,1233.656V1479.72l-46.847-27.056V1206.6Z",
    transform: "translate(-2170.1 -1179.497)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_96",
    "data-name": "<Path>",
    d: "M2270.7,1243.656l46.614-27.056v1.117l-46.614,27.056Z",
    transform: "translate(-2223.852 -1098.97)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_97",
    "data-name": "<Path>",
    d: "M2170.1,1216.6l46.847,27.056v1.118l-46.847-27.056Z",
    transform: "translate(-2170.1 -1098.97)",
    fill: "#ff20ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_98",
    "data-name": "<Path>",
    d: "M2264.145,964l-15.973,112.973-26.729,15.507-26.87-15.507L2178.6,964Z",
    transform: "translate(-2174.642 -964)",
    opacity: 0.6,
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_52",
    "data-name": "<Group>",
    transform: "translate(19.931 97.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_99",
    "data-name": "<Path>",
    d: "M2266.5,1188.754l-26.73,15.507-26.87-15.507,26.87-15.554Z",
    transform: "translate(-2212.9 -1173.2)",
    fill: "#a5ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_53",
    "data-name": "<Group>",
    transform: "translate(15.88 12.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_100",
    "data-name": "<Path>",
    d: "M2267.393,1040.9v7.544q-.838.512-1.723,1.071l-.186.093a1.245,1.245,0,0,0-.326.233q-.606.326-1.257.7a5.239,5.239,0,0,1-.559.326q-.745.419-1.49.792l-.373.186q-.885.512-1.863.978a3.258,3.258,0,0,0-.465.233q-.745.326-1.444.7l-.651.28q-.7.326-1.444.605l-.559.279q-1.024.419-2.049.791a1.842,1.842,0,0,1-.233.093q-.885.326-1.816.7a4.582,4.582,0,0,0-.7.233q-.745.233-1.49.512a3.245,3.245,0,0,0-.419.14.514.514,0,0,0-.233.047l-2.422.745a.518.518,0,0,1-.233.046q-1.117.326-2.188.605-.372.093-.7.186-1.164.279-2.328.512a.356.356,0,0,1-.14.047q-1.257.279-2.515.512a1.027,1.027,0,0,0-.326.047,1.034,1.034,0,0,1-.326.046q-1.443.28-2.887.466a.759.759,0,0,1-.232.047q-1.4.186-2.841.326a1.359,1.359,0,0,1-.326.047h-.233q-1.211.14-2.422.233h-.046l-2.328.093a.878.878,0,0,0-.28.046h-5.169q-.559-.047-1.164-.046-.512-.047-.978-.047l-1.211-.093a4.612,4.612,0,0,0-.652-.047,1.032,1.032,0,0,1-.326-.047l-1.21-.093q-.466-.047-.979-.093l-1.21-.186-.745-.093a.414.414,0,0,1-.187-.046q-.745-.093-1.444-.186-.419-.093-.792-.14l-1.863-.373a1.536,1.536,0,0,1-.373-.047h-.046a17.216,17.216,0,0,1-2.794-9.174l.047-7.544a16.744,16.744,0,0,0,2.748,9.174l.466.093q.884.186,1.816.326.419.093.792.14.745.14,1.444.233.465.047.978.14.605.047,1.211.14.465.047.978.093.605.093,1.164.14.512.047.978.047l1.211.093q.512.047.978.047.605.047,1.211.047.465,0,.931.046h2.282q.652,0,1.351-.046h.838q1.164-.047,2.328-.14h.093q1.212-.093,2.375-.186a3.694,3.694,0,0,1,.605-.047l2.794-.373h.232q1.491-.233,2.934-.466a3.512,3.512,0,0,1,.605-.14l2.515-.466a.355.355,0,0,1,.14-.047q1.21-.28,2.375-.559l.652-.186q1.117-.279,2.189-.559l.279-.093q1.211-.326,2.375-.7a5.49,5.49,0,0,1,.652-.233q.791-.233,1.537-.512a5.49,5.49,0,0,0,.652-.233q.931-.326,1.863-.7a.519.519,0,0,1,.233-.047q1.025-.419,2-.838a3.519,3.519,0,0,1,.6-.233l1.4-.652.652-.279q.745-.326,1.444-.7a2.561,2.561,0,0,0,.512-.233l1.863-.931.373-.186q.745-.419,1.444-.792a5.187,5.187,0,0,1,.559-.326q.652-.372,1.257-.745a5.231,5.231,0,0,0,.559-.326q.838-.512,1.676-1.071Z",
    transform: "translate(-2204.2 -1017.337)",
    fill: "#102465"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_54",
    "data-name": "<Group>",
    transform: "translate(0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_9",
    "data-name": "<Compound Path>",
    d: "M2267.416,1013.863c-15.041,9.779-37.673,16.159-60.4,11.456-8.2-13.132,2.794-26.264,19.6-35.019l25.845,8.615Z",
    transform: "translate(-2204.245 -990.3)",
    fill: "#00edf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_55",
    "data-name": "<Group>",
    transform: "translate(3.713 2.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_10",
    "data-name": "<Compound Path>",
    d: "M2267.089,1016.63a79.176,79.176,0,0,1-24.029,9.453,74.611,74.611,0,0,1-28.872.605c-2.98-5.4-2.655-11.036.978-16.718,3.167-5.029,8.755-9.826,16.206-13.97l22.632,7.544Z",
    transform: "translate(-2212.173 -996)",
    fill: "#1a6cbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_56",
    "data-name": "<Group>",
    transform: "translate(17.975 15.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_101",
    "data-name": "<Path>",
    d: "M2265.385,1028.655v3.213h-22.539l-.047-8.568h5.495l.047,5.355Z",
    transform: "translate(-2242.8 -1023.3)",
    fill: "#fdf7fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_57",
    "data-name": "<Group>",
    transform: "translate(15.88 149.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_102",
    "data-name": "<Path>",
    d: "M2217.332,1436.871l-13.132-7.591V1285.2l13.132,7.544Z",
    transform: "translate(-2204.2 -1285.2)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_103",
    "data-name": "<Path>",
    d: "M2217.332,1578.4v15.134l-13.132-7.591Z",
    transform: "translate(-2204.2 -1441.863)",
    fill: "url(#linear-gradient-38)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_104",
    "data-name": "<Path>",
    d: "M2263.561,1206.6v246.064l-46.614,27.056-46.847-27.056V1206.6l46.847,27.056Z",
    transform: "translate(-2170.1 -1093.626)",
    fill: "url(#linear-gradient-39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_58",
    "data-name": "<Group>",
    transform: "translate(557.835 60.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_59",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_60",
    "data-name": "<Group>",
    transform: "translate(0 45.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_61",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_62",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_105",
    "data-name": "<Path>",
    d: "M3330.508,947.843l-24.634,14.3-24.774-14.3,24.774-14.343Z",
    transform: "translate(-3281.1 -933.5)",
    fill: "url(#linear-gradient-40)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_106",
    "data-name": "<Path>",
    d: "M3358.934,964.3v218.123l-24.634,14.3V978.6Z",
    transform: "translate(-3309.525 -949.957)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_107",
    "data-name": "<Path>",
    d: "M3305.874,978.6v218.123l-24.774-14.3V964.3Z",
    transform: "translate(-3281.1 -949.957)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_108",
    "data-name": "<Path>",
    d: "M3334.3,983.9l24.634-14.3v.606L3334.3,984.5Z",
    transform: "translate(-3309.525 -907.385)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_109",
    "data-name": "<Path>",
    d: "M3281.1,969.6l24.774,14.3v.605l-24.774-14.3Z",
    transform: "translate(-3281.1 -907.385)",
    fill: "#ff20ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_110",
    "data-name": "<Path>",
    d: "M3330.817,836l-8.429,59.746-14.156,8.2-14.2-8.2L3285.6,836Z",
    transform: "translate(-3283.504 -836)",
    opacity: 0.6,
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_63",
    "data-name": "<Group>",
    transform: "translate(10.524 51.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_111",
    "data-name": "<Path>",
    d: "M3332.06,954.9l-14.157,8.2-14.2-8.2,14.2-8.2Z",
    transform: "translate(-3303.7 -946.7)",
    fill: "#a5ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_64",
    "data-name": "<Group>",
    transform: "translate(8.382 6.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_112",
    "data-name": "<Path>",
    d: "M3332.535,876.7v3.958l-.931.559-.093.093-.186.093-.652.373-.28.186a6.4,6.4,0,0,0-.792.419l-.186.093q-.512.279-.978.512a1.179,1.179,0,0,0-.28.14,7.776,7.776,0,0,0-.745.326l-.373.186a7.785,7.785,0,0,0-.745.326,2.556,2.556,0,0,0-.326.14q-.512.186-1.071.419a.135.135,0,0,0-.093.047q-.512.186-.978.373l-.372.093q-.373.14-.792.279l-.186.093h-.139q-.652.233-1.258.419h-.14q-.605.186-1.164.326l-.373.093q-.605.14-1.257.279l-.047.046q-.7.14-1.35.233a.356.356,0,0,1-.14.047.416.416,0,0,0-.186.047q-.745.14-1.537.233h-.139l-1.49.186a.412.412,0,0,0-.186.047h-.093q-.652.046-1.258.093h-.047q-.6.047-1.257.047a.191.191,0,0,1-.14.047h-2.7a4.588,4.588,0,0,0-.652-.047h-.512a4.6,4.6,0,0,0-.652-.047,1.027,1.027,0,0,0-.326-.047h-.187q-.326-.046-.605-.093a3.4,3.4,0,0,1-.559-.047,3.689,3.689,0,0,0-.605-.047c-.155-.031-.3-.062-.419-.093h-.093q-.373-.047-.791-.093c-.125-.031-.264-.062-.419-.093l-.931-.186a.518.518,0,0,1-.233-.046h0a9.024,9.024,0,0,1-1.49-4.843v-3.958a9.023,9.023,0,0,0,1.49,4.843.772.772,0,0,1,.233.047q.465.093.978.186a2.161,2.161,0,0,1,.419.047,6.3,6.3,0,0,1,.745.14,3.121,3.121,0,0,1,.512.047l.652.093a3.147,3.147,0,0,1,.512.047,4.287,4.287,0,0,0,.605.047,3.39,3.39,0,0,0,.559.047,3.691,3.691,0,0,0,.605.047,2.609,2.609,0,0,1,.512.047h1.164a4.956,4.956,0,0,0,.7.047h.466a6.017,6.017,0,0,0,.745-.047h.419q.652,0,1.257-.047h.046q.605-.047,1.257-.14h.28q.791-.093,1.536-.186a.134.134,0,0,0,.093-.047q.792-.093,1.537-.233a1.028,1.028,0,0,0,.326-.047q.7-.14,1.351-.279h.046q.652-.14,1.258-.279l.373-.093q.559-.14,1.164-.326a.359.359,0,0,0,.14-.047q.6-.186,1.257-.372c.125-.031.233-.062.326-.093l.838-.28a1.032,1.032,0,0,1,.326-.14q.513-.186.978-.373a.359.359,0,0,0,.14-.047q.512-.186,1.071-.419a1.174,1.174,0,0,0,.279-.14,6,6,0,0,0,.792-.326,2.535,2.535,0,0,0,.326-.14l.745-.373a1.179,1.179,0,0,0,.28-.14q.512-.233.978-.466a.73.73,0,0,0,.186-.14,6.381,6.381,0,0,0,.792-.419,1.175,1.175,0,0,0,.279-.14,3.366,3.366,0,0,0,.652-.419,1.03,1.03,0,0,0,.326-.14q.42-.279.885-.559Z",
    transform: "translate(-3299.1 -864.22)",
    fill: "#102465"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_65",
    "data-name": "<Group>",
    transform: "translate(0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_11",
    "data-name": "<Compound Path>",
    d: "M3332.559,862.38a44.083,44.083,0,0,1-31.945,6.054c-4.331-6.939,1.444-13.924,10.338-18.534l13.691,4.564Z",
    transform: "translate(-3299.144 -849.9)",
    fill: "#00edf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_66",
    "data-name": "<Group>",
    transform: "translate(1.96 1.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_12",
    "data-name": "<Compound Path>",
    d: "M3332.363,863.8a40.555,40.555,0,0,1-12.713,5.029,39.341,39.341,0,0,1-15.275.326,8.17,8.17,0,0,1,.513-8.848,23.319,23.319,0,0,1,8.568-7.4l12.014,4Z",
    transform: "translate(-3303.309 -852.9)",
    fill: "#1a6cbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_67",
    "data-name": "<Group>",
    transform: "translate(9.5 8.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_113",
    "data-name": "<Path>",
    d: "M3331.468,870.187v1.676H3319.5V867.3h2.934v2.887Z",
    transform: "translate(-3319.5 -867.3)",
    fill: "#fdf7fb"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_114",
    "data-name": "<Path>",
    d: "M3330.508,895.746v218.123l-24.634,14.3-24.774-14.3V895.746l9.733-5.635L3283.2,836h45.218l-7.637,54.065Z",
    transform: "translate(-3281.1 -836)",
    fill: "url(#linear-gradient-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_68",
    "data-name": "<Group>",
    transform: "translate(571.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_69",
    "data-name": "<Group>",
    transform: "translate(0 128.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_70",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_71",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_115",
    "data-name": "<Path>",
    d: "M3513.459,1039.594l-101.8,59.094L3309.4,1039.594,3411.662,980.5Z",
    transform: "translate(-3309.4 -980.5)",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_116",
    "data-name": "<Path>",
    d: "M3630.8,1107.4v276.845L3529,1443.339V1166.494Z",
    transform: "translate(-3426.737 -1048.305)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_117",
    "data-name": "<Path>",
    d: "M3411.662,1166.494v276.845L3309.4,1384.245V1107.4Z",
    transform: "translate(-3309.4 -1048.305)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_118",
    "data-name": "<Path>",
    d: "M3529,1188.394l101.8-59.095v1.537L3529,1189.931Z",
    transform: "translate(-3426.737 -931.946)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_119",
    "data-name": "<Path>",
    d: "M3309.4,1129.3l102.263,59.094v1.537L3309.4,1130.837Z",
    transform: "translate(-3309.4 -931.946)",
    fill: "#ff20ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_72",
    "data-name": "<Group>",
    transform: "translate(22.259 228.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_120",
    "data-name": "<Path>",
    d: "M3370.332,1348.418l-13.132-7.591V1196.7l13.132,7.591Z",
    transform: "translate(-3357.2 -1196.7)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_121",
    "data-name": "<Path>",
    d: "M3370.332,1489.9v15.181l-13.132-7.59Z",
    transform: "translate(-3357.2 -1353.363)",
    fill: "url(#linear-gradient-49)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_73",
    "data-name": "<Group>",
    transform: "translate(44.752 241.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_122",
    "data-name": "<Path>",
    d: "M3418.632,1375.971l-13.132-7.544V1224.3l13.132,7.59Z",
    transform: "translate(-3405.5 -1224.3)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_123",
    "data-name": "<Path>",
    d: "M3418.632,1517.5v15.135l-13.132-7.544Z",
    transform: "translate(-3405.5 -1380.963)",
    fill: "url(#linear-gradient-51)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_124",
    "data-name": "<Path>",
    d: "M3518.059,705.5l-26.451,187.063-44.285,25.659-44.472-25.659L3376.4,705.5Z",
    transform: "translate(-3345.199 -705.5)",
    opacity: 0.6,
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_74",
    "data-name": "<Group>",
    transform: "translate(57.651 161.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_125",
    "data-name": "<Path>",
    d: "M3521.958,1077.705l-44.286,25.659-44.472-25.659L3477.672,1052Z",
    transform: "translate(-3433.2 -1052)",
    fill: "#a5ffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_75",
    "data-name": "<Group>",
    transform: "translate(426.747 228.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_76",
    "data-name": "<Group>",
    transform: "translate(0 67.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_77",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_78",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_79",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_126",
    "data-name": "<Path>",
    d: "M3203.66,1398.941l-101.844,59.094L2999.6,1398.941l102.216-59.141Z",
    transform: "translate(-2999.6 -1339.8)",
    fill: "url(#linear-gradient-53)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_127",
    "data-name": "<Path>",
    d: "M3320.943,1466.8v146.13L3219.1,1672.024V1525.894Z",
    transform: "translate(-3116.884 -1407.659)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_128",
    "data-name": "<Path>",
    d: "M3101.816,1525.894v146.13L2999.6,1612.929V1466.8Z",
    transform: "translate(-2999.6 -1407.659)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_129",
    "data-name": "<Path>",
    d: "M3219.1,1547.694l101.844-59.095v1.537L3219.1,1549.231Z",
    transform: "translate(-3116.884 -1419.307)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_130",
    "data-name": "<Path>",
    d: "M2999.6,1488.6l102.216,59.095v1.537L2999.6,1490.137Z",
    transform: "translate(-2999.6 -1419.307)",
    fill: "#ff20ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_80",
    "data-name": "<Group>",
    transform: "translate(46.055 89.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_81",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_131",
    "data-name": "<Path>",
    d: "M3204.022,1433.2l-.047,3.772v.233a.769.769,0,0,1-.047.233v.047a.357.357,0,0,1-.047.14.781.781,0,0,1-.046.233v.047l-.093.093a1.829,1.829,0,0,1-.093.233v.093l-.093.093a1.574,1.574,0,0,1-.187.233.133.133,0,0,1-.046.093.135.135,0,0,0-.046.093l-.326.326a.133.133,0,0,1-.093.047.041.041,0,0,1-.047.047l-.186.186a258.911,258.911,0,0,0-.466.372,1.845,1.845,0,0,1-.233.093.041.041,0,0,1-.046.047l-62.168,36.136a11.349,11.349,0,0,1-10.385,0l-28.639-16.531a3.752,3.752,0,0,1-2.189-3.027l.047-3.818c-.047,1.117.7,2.188,2.142,3.027l28.639,16.531a11.35,11.35,0,0,0,10.385,0l62.168-36.09.28-.186a1.526,1.526,0,0,0,.233-.186.59.59,0,0,0,.233-.14,1.466,1.466,0,0,1,.233-.186.54.54,0,0,1,.093-.14,1.635,1.635,0,0,0,.326-.326.3.3,0,0,1,.139-.14,1.186,1.186,0,0,0,.14-.279.541.541,0,0,0,.093-.14,2.421,2.421,0,0,0,.139-.233.41.41,0,0,0,.047-.186,1.809,1.809,0,0,0,.093-.233.414.414,0,0,1,.046-.186v-.233A.412.412,0,0,0,3204.022,1433.2Z",
    transform: "translate(-3098.499 -1412.384)",
    fill: "#162a56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_82",
    "data-name": "<Group>",
    transform: "translate(0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_13",
    "data-name": "<Compound Path>",
    d: "M3201.853,1406.289c2.887,1.63,2.887,4.331.047,6.007l-62.168,36.09a11.351,11.351,0,0,1-10.385,0l-28.639-16.532c-2.887-1.63-2.887-4.331-.046-6.007l62.168-36.09a11.35,11.35,0,0,1,10.385,0Zm-63.611,41.259,62.167-36.136c2.049-1.164,2-3.12-.047-4.284l-2.561-1.49-3.912.093-19.745-11.409.186-2.235-2.608-1.49a8.285,8.285,0,0,0-7.4,0l-62.168,36.09c-2,1.211-2,3.12.047,4.331l28.639,16.532a8.286,8.286,0,0,0,7.4,0Z",
    transform: "translate(-3098.537 -1388.5)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_83",
    "data-name": "<Group>",
    transform: "translate(2.136 1.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_132",
    "data-name": "<Path>",
    d: "M3202.795,1408.53c2.049,1.211,2.049,3.12.046,4.284l-62.168,36.137a8.284,8.284,0,0,1-7.4,0l-28.639-16.531c-2.05-1.211-2.05-3.12-.046-4.284L3166.751,1392a8.286,8.286,0,0,1,7.4,0l2.608,1.49-.186,2.235,19.744,11.409,3.912-.093Z",
    transform: "translate(-3103.087 -1391.125)",
    fill: "#165da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_84",
    "data-name": "<Group>",
    transform: "translate(2.136 1.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_133",
    "data-name": "<Path>",
    d: "M3202.795,1408.53c2.049,1.211,2.049,3.12.046,4.284l-62.168,36.137a8.284,8.284,0,0,1-7.4,0l-28.639-16.531c-2.05-1.211-2.05-3.12-.046-4.284L3166.751,1392a8.286,8.286,0,0,1,7.4,0l2.608,1.49-.186,2.235,19.744,11.409,3.912-.093Z",
    transform: "translate(-3103.087 -1391.125)",
    fill: "#165da4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_85",
    "data-name": "<Group>",
    transform: "translate(54.1 48.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_86",
    "data-name": "<Group>",
    transform: "translate(0 54.15)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_134",
    "data-name": "<Path>",
    d: "M3131.433,1417.316c3.586,2.1,3.632,5.448.047,7.5a14.354,14.354,0,0,1-12.992.047c-3.586-2.1-3.632-5.448-.047-7.544A14.353,14.353,0,0,1,3131.433,1417.316Z",
    transform: "translate(-3115.774 -1415.762)",
    fill: "#1a9bdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_87",
    "data-name": "<Group>",
    transform: "translate(0.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_88",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_135",
    "data-name": "<Path>",
    d: "M3124.907,1422.5a10.078,10.078,0,0,0,2.049,3.166c1.071.838,1.35,1.351.885,1.77-.512.419-1.63.14-2.887-.512a12.524,12.524,0,0,1-2.655-2,16,16,0,0,1,.14-2.142c.093-.186.605-.279.605-.279S3124.907,1422.547,3124.907,1422.5Z",
    transform: "translate(-3119.925 -1365.213)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_136",
    "data-name": "<Path>",
    d: "M3139.308,1416.8a11.749,11.749,0,0,0,2.049,3.12c1.071.838,1.35,1.351.885,1.77-.512.419-1.63.14-2.887-.512a14.09,14.09,0,0,1-2.654-2,16.037,16.037,0,0,1,.14-2.142c.093-.187.605-.233.605-.233Z",
    transform: "translate(-3127.619 -1362.166)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_137",
    "data-name": "<Path>",
    d: "M3146.569,1334.2c.28-.093.792,12.48.885,13.039a14.048,14.048,0,0,1,.14,3.818c-.093.093-.745.28-1.025.419-.233.093-.6-.139-.7-.186-.046-.047-.6.047-.7-.093a4.508,4.508,0,0,1-.047-.745s-.326-.233-.326-.512a8.413,8.413,0,0,1,.652-1.3c0-.14.046-.792.046-.792S3146.011,1334.385,3146.569,1334.2Z",
    transform: "translate(-3131.947 -1318.031)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_138",
    "data-name": "<Path>",
    d: "M3143.126,1330.807c-.187-1.211-.326-2.282-.326-2.282l.419-7.125c1.211.047,1.63,1.676,2.188,3.772.279.978.605,2.421.838,3.679A23.47,23.47,0,0,1,3143.126,1330.807Z",
    transform: "translate(-3130.878 -1311.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_139",
    "data-name": "<Path>",
    d: "M3133.735,1362.2l-1.723,25.612a2.834,2.834,0,0,1-3.306.373s-.373-21.607-.419-21.1c-.047.559-3.074,23.656-3.074,23.656a3.332,3.332,0,0,1-3.213.093l.093-26.776Z",
    transform: "translate(-3119.764 -1332.993)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_140",
    "data-name": "<Path>",
    d: "M3128.282,1321.079a12.217,12.217,0,0,1,2.7.14,16.965,16.965,0,0,1,1.862,6.24c.373,3.725,0,12.48,0,12.48s-1.024,1.583-4.843,2.608c-4.7,1.211-7.032-.466-7.032-.466l-1.071-17.789a15.028,15.028,0,0,1,3.772-2.189Z",
    transform: "translate(-3118.643 -1311.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_141",
    "data-name": "<Path>",
    d: "M3132.281,1299.862a3.682,3.682,0,0,1,1.536,1.257,3.225,3.225,0,0,1,.187,2.189c-.093.606.046,1.351-.419,1.816a4.472,4.472,0,0,1-1.3.512l-4.1,1.676s-.512.605-1.211-1.024a6.941,6.941,0,0,1-.838-3.958c.279-1.816,1.676-2.655,3.4-2.794a5.069,5.069,0,0,1,2.375.186A1.821,1.821,0,0,1,3132.281,1299.862Z",
    transform: "translate(-3121.942 -1299.48)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_142",
    "data-name": "<Path>",
    d: "M3128.621,1311.7l-.093-3.539a.867.867,0,0,1-.745-1.071c.139-.978,1.071-.326,1.257-.047,0,0,.186-3.353,2-3.679,1.77-.326,3.493.047,3.539.932a45.218,45.218,0,0,1,0,5.029c-.093,1.164-.978,1.63-2.608,1.583l.093,1.816s-.791.605-3.12.046Z",
    transform: "translate(-3122.846 -1301.494)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_143",
    "data-name": "<Path>",
    d: "M3132.1,1320.5a2.139,2.139,0,0,1,.466.047,2.464,2.464,0,0,1,.791,1.443,5.379,5.379,0,0,1-.279,1.537l-1.49-1.3-.931,1.77a3.431,3.431,0,0,1-1.4-.7,5.122,5.122,0,0,1-1.258-1.49,10.132,10.132,0,0,1,.419-1.024c.046-.187.326-.233.326-.233a5.988,5.988,0,0,0,2.841,1.49S3132,1321.85,3132.1,1320.5Z",
    transform: "translate(-3122.97 -1310.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_144",
    "data-name": "<Path>",
    d: "M3119.9,1353.679s.187.652.233.792.792.838.885,1.118a.99.99,0,0,1-.187.605s.093.605.093.745c-.047.14-.652.186-.7.233a.948.948,0,0,1-.651.279c-.233-.047-.978-.14-1.071-.187a12.936,12.936,0,0,1-.605-3.772c0-.652.186-12.992.186-12.992.187.046,2.7,1.024,2.7,1.024Z",
    transform: "translate(-3117.574 -1321.398)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_145",
    "data-name": "<Path>",
    d: "M3117.2,1334.594c.186-2.561.373-6.38,1.258-6.892,2.1-1.3,2.1,2.654,2.188,4.051,0,.419-.046,2.142-.093,3.679A6.623,6.623,0,0,1,3117.2,1334.594Z",
    transform: "translate(-3117.199 -1314.421)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_146",
    "data-name": "<Path>",
    d: "M3135.919,1303.926c-.047.652-.7.047-.932-.046-.465-.14-.745.279-1.164.372-1.025.186-1.723-1.257-1.723-2.1.093-1.723,2.841-1.164,3.819-.7a2.772,2.772,0,0,1,1.024.792,1.348,1.348,0,0,1,.093,1.257A.917.917,0,0,1,3135.919,1303.926Z",
    transform: "translate(-3124.498 -1300.285)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_147",
    "data-name": "<Path>",
    d: "M3129.591,1303.945c.187-.373.466-.745.885-.745.373.046.605.465.7.838a3.17,3.17,0,0,1-.745,2.7,12.161,12.161,0,0,1,0,1.3h-.326a2.759,2.759,0,0,0-.931-1.723A4.693,4.693,0,0,1,3129.591,1303.945Z",
    transform: "translate(-3122.92 -1301.468)",
    fill: "#103450"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_148",
    "data-name": "<Path>",
    d: "M3198.819,1195.8c-5.123,41.12-15.693,110.552-15.693,110.552a2.575,2.575,0,0,1-1.49,2.1l-62.167,36.136a8.286,8.286,0,0,1-7.4,0l-28.639-16.532a2.859,2.859,0,0,1-1.49-1.816h-.046s-18.208-113.16-18.488-130.436Z",
    transform: "translate(-3033.69 -1195.8)",
    opacity: 0.6,
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_89",
    "data-name": "<Group>",
    transform: "translate(90.528 44.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_90",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_91",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_14",
    "data-name": "<Compound Path>",
    d: "M3240.242,1291.74l.186,59.048a4.551,4.551,0,0,1-2.049,3.539l-42.144,24.355c-1.164.652-2.1.14-2.1-1.164l-.14-59.048a4.582,4.582,0,0,1,2.049-3.586l42.144-24.308c1.117-.652,2.049-.14,2.049,1.164ZM3206.62,1363.5a1.653,1.653,0,0,0,.7-1.257c0-.419-.326-.605-.745-.419l-5.914,3.446a1.653,1.653,0,0,0-.7,1.257c0,.419.326.605.7.373Zm8.335-8.289a1.653,1.653,0,0,0,.7-1.257c0-.466-.326-.652-.7-.419l-14.25,8.242a1.528,1.528,0,0,0-.7,1.257c0,.466.326.652.7.419Zm7.218-4.191a1.643,1.643,0,0,0,.7-1.211c0-.466-.325-.652-.7-.419l-4.377,2.515a1.576,1.576,0,0,0-.745,1.257c0,.465.326.652.745.419Zm12.2-.047-.047-12.154-8.568,4.936.047,12.154Zm-29.291,6.38a1.576,1.576,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-4.377,2.515a1.653,1.653,0,0,0-.7,1.257c0,.466.326.652.7.419Zm17.044-9.826a1.574,1.574,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-14.2,8.243a1.566,1.566,0,0,0-.745,1.211c0,.466.326.652.745.419Zm-14.669,1.443a1.575,1.575,0,0,0,.745-1.257c0-.465-.326-.652-.745-.419l-6.8,3.912a1.653,1.653,0,0,0-.7,1.257c0,.466.326.652.7.419Zm19.745-14.9a1.577,1.577,0,0,0,.745-1.257c0-.419-.326-.605-.745-.373l-26.544,15.274a1.653,1.653,0,0,0-.7,1.257c0,.466.326.652.7.419Zm6.38-3.679a1.575,1.575,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-3.539,2.049a1.576,1.576,0,0,0-.745,1.257c0,.466.326.652.745.419Zm-12.108,3.493a1.653,1.653,0,0,0,.7-1.257c0-.466-.326-.652-.7-.419l-20.815,12.015a1.652,1.652,0,0,0-.7,1.257c0,.419.326.652.7.419Zm12.108-6.985a1.648,1.648,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-8.941,5.169a1.493,1.493,0,0,0-.7,1.211c0,.466.325.652.7.419Zm0-3.493a1.575,1.575,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-32.877,19a1.576,1.576,0,0,0-.745,1.257c0,.466.326.652.745.419Zm.7-5.774-.046-18.068-34.041,19.652.046,18.068Zm-12.108,40.467a1.576,1.576,0,0,0,.745-1.257c0-.466-.326-.652-.745-.419l-3.539,2.049a1.576,1.576,0,0,0-.745,1.257c0,.466.326.652.745.419Z",
    transform: "translate(-3194 -1290.293)",
    fill: "#00edf9",
    fillRule: "evenodd",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_149",
    "data-name": "<Path>",
    d: "M3241.234,1328.268l-34.087,19.652-.047-18.068,34.041-19.652Z",
    transform: "translate(-3200.999 -1300.93)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_150",
    "data-name": "<Path>",
    d: "M3240.967,1358.1a1.566,1.566,0,0,1-.745,1.211l-32.876,19c-.419.233-.745.047-.745-.419a1.565,1.565,0,0,1,.745-1.211l32.876-19C3240.64,1357.452,3240.967,1357.638,3240.967,1358.1Z",
    transform: "translate(-3200.732 -1326.249)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_151",
    "data-name": "<Path>",
    d: "M3228.912,1380.6a1.654,1.654,0,0,1-.7,1.257l-20.815,12.015c-.373.233-.7,0-.7-.419a1.529,1.529,0,0,1,.7-1.257l20.769-12.014C3228.586,1379.952,3228.912,1380.138,3228.912,1380.6Z",
    transform: "translate(-3200.786 -1338.271)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_152",
    "data-name": "<Path>",
    d: "M3268.484,1365.6a1.574,1.574,0,0,1-.745,1.257l-8.941,5.169c-.373.233-.7,0-.7-.419a1.655,1.655,0,0,1,.7-1.257l8.941-5.169C3268.158,1364.952,3268.484,1365.138,3268.484,1365.6Z",
    transform: "translate(-3228.25 -1330.256)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_153",
    "data-name": "<Path>",
    d: "M3234.687,1381a1.576,1.576,0,0,1-.745,1.257l-26.543,15.321c-.373.233-.7.047-.7-.419a1.652,1.652,0,0,1,.7-1.257l26.543-15.321C3234.361,1380.352,3234.64,1380.538,3234.687,1381Z",
    transform: "translate(-3200.786 -1338.484)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_154",
    "data-name": "<Path>",
    d: "M3274.682,1373.146a1.651,1.651,0,0,1-.7,1.257l-3.586,2.049c-.373.233-.7.047-.7-.419a1.566,1.566,0,0,1,.7-1.211l3.586-2.049C3274.357,1372.54,3274.682,1372.68,3274.682,1373.146Z",
    transform: "translate(-3234.448 -1334.305)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_155",
    "data-name": "<Path>",
    d: "M3214.942,1413a1.575,1.575,0,0,1-.745,1.257l-6.752,3.911c-.419.233-.745.047-.745-.419a1.576,1.576,0,0,1,.745-1.257l6.752-3.912C3214.616,1412.352,3214.942,1412.538,3214.942,1413Z",
    transform: "translate(-3200.786 -1355.583)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_156",
    "data-name": "<Path>",
    d: "M3249.22,1417.5a1.576,1.576,0,0,1-.745,1.257l-4.378,2.515c-.372.233-.7.046-.7-.419a1.655,1.655,0,0,1,.7-1.257l4.378-2.515C3248.894,1416.852,3249.22,1417.038,3249.22,1417.5Z",
    transform: "translate(-3220.395 -1357.987)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_157",
    "data-name": "<Path>",
    d: "M3222.446,1426.4a1.653,1.653,0,0,1-.7,1.257l-14.25,8.2c-.373.233-.7.047-.7-.419a1.528,1.528,0,0,1,.7-1.257l14.25-8.2C3222.12,1425.752,3222.446,1425.938,3222.446,1426.4Z",
    transform: "translate(-3200.839 -1362.743)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_158",
    "data-name": "<Path>",
    d: "M3250.182,1432.5a1.652,1.652,0,0,1-.7,1.257l-3.585,2.049c-.373.233-.7.047-.7-.419a1.565,1.565,0,0,1,.7-1.211l3.585-2.1C3249.857,1431.852,3250.182,1432.038,3250.182,1432.5Z",
    transform: "translate(-3221.357 -1366.002)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_159",
    "data-name": "<Path>",
    d: "M3214.157,1444.236a1.654,1.654,0,0,1-.7,1.257l-5.961,3.4c-.373.233-.7.047-.7-.373a1.653,1.653,0,0,1,.7-1.257l5.914-3.446C3213.831,1443.631,3214.157,1443.817,3214.157,1444.236Z",
    transform: "translate(-3200.84 -1372.286)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_160",
    "data-name": "<Path>",
    d: "M3212.567,1431.1a1.576,1.576,0,0,1-.745,1.257l-4.377,2.515c-.419.233-.745.046-.745-.419a1.575,1.575,0,0,1,.745-1.257l4.377-2.515C3212.241,1430.452,3212.567,1430.638,3212.567,1431.1Z",
    transform: "translate(-3200.786 -1365.254)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_161",
    "data-name": "<Path>",
    d: "M3237.892,1410a1.566,1.566,0,0,1-.745,1.211l-14.25,8.243c-.373.233-.7.046-.7-.419a1.653,1.653,0,0,1,.7-1.257l14.25-8.2C3237.567,1409.352,3237.892,1409.538,3237.892,1410Z",
    transform: "translate(-3209.067 -1353.98)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_162",
    "data-name": "<Path>",
    d: "M3270.715,1406.754l-8.615,4.936v-12.154l8.568-4.936Z",
    transform: "translate(-3230.387 -1346.026)",
    fill: "#a5ffff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_92",
    "data-name": "<Group>",
    transform: "translate(113.998 223.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_163",
    "data-name": "<Path>",
    d: "M2459.414,1185.1v144.081l-65.567,38.046L2328,1329.181V1185.1Z",
    transform: "translate(-2328 -1185.1)",
    opacity: 0.6,
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_93",
    "data-name": "<Group>",
    transform: "translate(0 73.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_94",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_95",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_96",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_164",
    "data-name": "<Path>",
    d: "M2459.414,1380.146l-65.567,38.046L2328,1380.146l65.847-38.046Z",
    transform: "translate(-2328 -1342.1)",
    fill: "url(#linear-gradient-59)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_165",
    "data-name": "<Path>",
    d: "M2534.967,1423.8v144.127l-65.567,38.046V1461.846Z",
    transform: "translate(-2403.553 -1385.754)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_166",
    "data-name": "<Path>",
    d: "M2393.847,1461.846v144.127L2328,1567.927V1423.8Z",
    transform: "translate(-2328 -1385.754)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_167",
    "data-name": "<Path>",
    d: "M2469.4,1475.946l65.567-38.046v1.583l-65.567,38.046Z",
    transform: "translate(-2403.553 -1393.288)",
    fill: "#ff65eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_168",
    "data-name": "<Path>",
    d: "M2328,1437.9l65.847,38.046v1.583L2328,1439.483Z",
    transform: "translate(-2328 -1393.288)",
    fill: "#ff20ce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_97",
    "data-name": "<Group>",
    transform: "translate(76.371 96.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_169",
    "data-name": "<Path>",
    d: "M2509.724,1460.659a15.192,15.192,0,0,1-13.737,0c-3.819-2.189-3.865-5.775-.047-7.963,3.772-2.235,9.919-2.188,13.737,0S2513.5,1458.471,2509.724,1460.659Z",
    transform: "translate(-2492.587 -1424.01)",
    fill: "#1a9bdb",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_170",
    "data-name": "<Path>",
    d: "M2530.115,1506.6a9.451,9.451,0,0,0,1.956,2.98c1.024.838,1.3,1.3.838,1.723s-1.537.14-2.747-.512a11.523,11.523,0,0,1-2.562-1.909,14.665,14.665,0,0,1,.14-2.049c.093-.186.605-.233.605-.233Z",
    transform: "translate(-2511.021 -1453.699)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_171",
    "data-name": "<Path>",
    d: "M2534.68,1496.192a11.408,11.408,0,0,0,1.165,3.446c.792,1.024.931,1.583.373,1.863s-1.537-.279-2.562-1.211a11.8,11.8,0,0,1-1.956-2.468,12.06,12.06,0,0,1,.652-1.956c.139-.186.652-.093.652-.093l1.676.419Z",
    transform: "translate(-2513.213 -1447.902)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_172",
    "data-name": "<Path>",
    d: "M2506.76,1454.115s6.986,7.544,7.265,8.755c.279,1.164,1.63,14.529,1.63,14.529a2.567,2.567,0,0,1-3.26,0l-2.049-11.875s-7.544-5.821-9.407-7.078c-1.164-.791-1.49-4.517-1.444-6.845Z",
    transform: "translate(-2496.002 -1424.311)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_173",
    "data-name": "<Path>",
    d: "M2519.17,1450.676s11.5,5.588,11.5,6.8c-.047,1.211-6.1,14.2-6.1,14.2-2.282.7-3.167-.838-3.167-.838l3.353-11.363s-11.41-3.4-12.527-4.564c-.978-1.024-.558-3.679.047-5.914Z",
    transform: "translate(-2502.499 -1422.922)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_98",
    "data-name": "<Group>",
    transform: "translate(8.615 23.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_99",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_100",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_101",
    "data-name": "<Group>",
    transform: "translate(8.382 6.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_174",
    "data-name": "<Path>",
    d: "M2539.676,1459.293l-11.177,6.519a.189.189,0,0,0,.047-.14l11.176-6.473c0,.062-.016.093-.047.093Z",
    transform: "translate(-2528.5 -1459.2)",
    fill: "#011c63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_102",
    "data-name": "<Group>",
    transform: "translate(8.429 6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_175",
    "data-name": "<Path>",
    d: "M2528.6,1465.119l11.176-6.519v.279l-11.176,6.473Z",
    transform: "translate(-2528.6 -1458.6)",
    fill: "#011c63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_103",
    "data-name": "<Group>",
    transform: "translate(0 1.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_176",
    "data-name": "<Path>",
    d: "M2510.5,1454.519l11.176-6.519,8.336,4.843-11.176,6.473Z",
    transform: "translate(-2510.5 -1448)",
    fill: "#fcfefb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_104",
    "data-name": "<Group>",
    transform: "translate(4.75 4.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_177",
    "data-name": "<Path>",
    d: "M2533.04,1455.5c.14.093.14.233,0,.372l-8.429,4.843a.488.488,0,0,1-.605,0l-3.167-1.816a.194.194,0,0,1,0-.373l8.382-4.843a.488.488,0,0,1,.605,0Z",
    transform: "translate(-2520.7 -1453.575)",
    fill: "#103450"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_178",
    "data-name": "<Path>",
    d: "M2529.447,1458.62l3.446-6.1,11.176-6.52-3.446,6.147-.046.047-11.176,6.473A.041.041,0,0,0,2529.447,1458.62Z",
    transform: "translate(-2520.598 -1445.208)",
    fill: "#fcfefb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_105",
    "data-name": "<Group>",
    transform: "translate(0 6.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_179",
    "data-name": "<Path>",
    d: "M2522.561,1458.3l.093.093a.684.684,0,0,1,.14.7l-3.447,6.1a.41.41,0,0,1-.605.093l-7.87-4.517a.856.856,0,0,1-.373-.652v-.093l8.336,4.8Z",
    transform: "translate(-2510.5 -1458.3)",
    fill: "#fcfefb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_180",
    "data-name": "<Path>",
    d: "M2536.4,1450.819l11.176-6.519.093.14a.605.605,0,0,1,.14.652l-11.176,6.52a.682.682,0,0,0-.139-.7Z",
    transform: "translate(-2524.339 -1444.3)",
    fill: "#fcfefb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_106",
    "data-name": "<Group>",
    transform: "translate(6.535 3.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_181",
    "data-name": "<Path>",
    d: "M2529.035,1453.2c.047,0,.047.093,0,.14l-2.794,1.63h-.279l-1.4-.838c-.046-.046-.046-.093.047-.14l2.748-1.63a.3.3,0,0,1,.279,0Z",
    transform: "translate(-2524.534 -1452.325)",
    fill: "#103450"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_182",
    "data-name": "<Path>",
    d: "M2522.952,1427.9s1.211,3.12,1.49,3.958a68.374,68.374,0,0,0,3.307,6.24,25.873,25.873,0,0,1,2.282,2.189.838.838,0,0,1-.838.838c-.7.047-2.514-1.257-2.514-1.257s-.466,1.164-.652-.233.373-1.211-.093-1.909c0,0-3.073-2.049-3.818-4.7a10.185,10.185,0,0,1-.093-4.843Z",
    transform: "translate(-2507.91 -1411.648)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_183",
    "data-name": "<Path>",
    d: "M2521.125,1423.151l-1.025-7.451c1.118.14,2.282,3.539,2.84,6.147A4.262,4.262,0,0,1,2521.125,1423.151Z",
    transform: "translate(-2507.015 -1405.129)",
    fill: "#fcfefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_184",
    "data-name": "<Path>",
    d: "M2505.3,1415.36a8.818,8.818,0,0,1,2.561.14s1.444,1.35,1.77,4.89a99.107,99.107,0,0,1,0,10.85s-.932,1.537-4.61,2.515c-4.517,1.164-6.752-.419-6.752-.419l-1.071-14.9a15.4,15.4,0,0,1,3.632-2.142Z",
    transform: "translate(-2494.779 -1404.929)",
    fill: "#fcfefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_185",
    "data-name": "<Path>",
    d: "M2510.106,1398.169a6.784,6.784,0,0,1-.047,2.282l-5.075,2.049s-.466.559-1.164-1.025c-.7-1.537-2.049-4.843.279-5.728a8.7,8.7,0,0,1,4.7-.28,3.024,3.024,0,0,1,1.3,2.7Z",
    transform: "translate(-2497.766 -1394.211)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_186",
    "data-name": "<Path>",
    d: "M2505.621,1406.322l-.093-3.446a.792.792,0,0,1-.745-.978c.186-.978,1.071-.326,1.21-.047,0,0,.187-3.26,1.909-3.586s3.4.047,3.446.885.093,3.772,0,4.89c-.093,1.071-.978,1.537-2.515,1.49l.093,1.723s-.792.605-2.98.047Z",
    transform: "translate(-2498.823 -1395.751)",
    fill: "#ffc6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_187",
    "data-name": "<Path>",
    d: "M2508.958,1414.7s.326,0,.419.093a1.919,1.919,0,0,1,.745,1.4,4.669,4.669,0,0,1-.233,1.49l-1.443-1.3-.885,1.723a3.44,3.44,0,0,1-1.351-.7,4.91,4.91,0,0,1-1.211-1.444c.233-.605.419-.978.419-.978.046-.14.326-.186.326-.186a6.338,6.338,0,0,0,2.7,1.444s.418-.233.512-1.537Z",
    transform: "translate(-2498.946 -1404.595)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_188",
    "data-name": "<Path>",
    d: "M2492,1427.728c.7-2.282,1.723-4.936,2.422-5.728a2.9,2.9,0,0,1,2.049,2.282c.279,1.443-.7,4.284-1.165,5.4-1.118-.652-2.188-1.351-3.306-1.956Z",
    transform: "translate(-2491.999 -1408.495)",
    fill: "#fcfefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_189",
    "data-name": "<Path>",
    d: "M2513.315,1396.353a1.911,1.911,0,0,1-.7,1.3,2.03,2.03,0,0,1-1.863-.047,3.944,3.944,0,0,0-1.863-.466,2.352,2.352,0,0,1-2.1-.326,1.763,1.763,0,0,1-.186,1.723,2.122,2.122,0,0,0-.233,1.071l-.373.093a6.433,6.433,0,0,1-1.024-2.421c-.047-.559-.28-1.071-.28-1.677a2.579,2.579,0,0,1,.14-.792l.186-.466a2.5,2.5,0,0,1,2.328-1.35,8.424,8.424,0,0,1,1.025.279c1.49.233,3.166-.605,4.331.838a2.708,2.708,0,0,1,.466.885,3.438,3.438,0,0,1,.139,1.35Z",
    transform: "translate(-2498.786 -1393)",
    fill: "#103450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_190",
    "data-name": "<Path>",
    d: "M2496.673,1437.23l-.14,1.164,7.172,6.892,1.4.233c2.468-.326.885.419.885.419s1.444.14,1.677.838c.186.605.279,2.142-.326,2.049-.605-.14-1.211-1.257-2.421-1.257-1.211.046-2.981-1.49-3.539-2.049-.512-.558-6.986-4.377-7.684-5.169-.652-.792.093-4.75.093-4.75Z",
    transform: "translate(-2492.761 -1415.762)",
    fill: "#ffc6a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_107",
    "data-name": "<Group>",
    transform: "translate(36.928 29.737)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_15",
    "data-name": "<Compound Path>",
    d: "M2460.107,1250.56l.14,51.271a4.809,4.809,0,0,1-2.235,3.819l-48.337,27.941c-1.211.7-2.235.14-2.235-1.3l-.14-51.271a4.809,4.809,0,0,1,2.236-3.819l48.337-27.941C2459.083,1248.558,2460.107,1249.117,2460.107,1250.56Zm-5.448,50.386a.718.718,0,0,0,.419-.605c0-.28-.187-.373-.419-.233l-40.7,23.517-.093-31.9c0-.279-.186-.373-.372-.233a.8.8,0,0,0-.373.652l.093,32.318c0,.233.139.326.373.233Zm-33.017,3.539-4.656,2.7v11.083l4.656-2.7v-11.083Zm8.895,5.961-.047-11.968v-7.451l-4.657,2.7v7.4l.047,12.014Zm17.742-10.245-.047-16.205-.046-10.059-4.657,2.654.047,10.059.046,16.252Zm-8.941-11.6-4.656,2.7.047,6.38v10.292l4.656-2.654v-10.292Zm-5.914-13.179a1.575,1.575,0,0,0,.745-1.257c0-.466-.326-.7-.745-.419l-11.875,6.846a1.591,1.591,0,0,0-.745,1.3c0,.466.327.652.745.419Zm5.262-3.073a1.576,1.576,0,0,0,.745-1.257c0-.465-.326-.652-.745-.419l-2.747,1.583a1.576,1.576,0,0,0-.745,1.257c0,.466.326.7.745.419Zm-20.815,12.2v-2.049l-4.424,2.608v2Zm12.107-11.688a1.469,1.469,0,0,0,.186-.745v-.14l-.046-.14-.047-.093-.094-.093c-.139-.093-.326-.047-.558.047a1.99,1.99,0,0,0-.513.559l-.093.186-.047.186-.047.186v.186a.49.49,0,0,0,.186.465c.14.094.326.047.559-.046A1.983,1.983,0,0,0,2429.978,1272.866Zm-2.7,1.816a1.655,1.655,0,0,0,.7-1.257c0-.512-.326-.7-.745-.466l-5.728,3.353a1.576,1.576,0,0,0-.745,1.257c0,.466.326.7.745.419Zm11.362-6.566a1.574,1.574,0,0,0,.745-1.257c0-.466-.326-.7-.745-.419l-6.891,3.958a1.658,1.658,0,0,0-.745,1.3.456.456,0,0,0,.745.419Zm-20.769,12.154v-2l-4.471,2.561v2Z",
    transform: "translate(-2407.299 -1248.957)",
    fill: "#00edf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_191",
    "data-name": "<Path>",
    d: "M2420.545,1340.459l.093,31.9,40.7-23.517c.233-.14.419-.047.419.233a.717.717,0,0,1-.419.605l-41.073,23.75c-.232.093-.373,0-.373-.233l-.093-32.318a.8.8,0,0,1,.373-.652C2420.358,1340.086,2420.545,1340.18,2420.545,1340.459Z",
    transform: "translate(-2413.979 -1297.69)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_192",
    "data-name": "<Path>",
    d: "M2432.856,1384.245l-4.657,2.654v-6.846l4.611-2.654Z",
    transform: "translate(-2418.467 -1317.587)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_193",
    "data-name": "<Path>",
    d: "M2451.856,1367.314l-4.656,2.655V1358l4.61-2.7Z",
    transform: "translate(-2428.619 -1305.778)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_194",
    "data-name": "<Path>",
    d: "M2470.9,1358.292l-4.657,2.7-.047-10.338,4.657-2.654Z",
    transform: "translate(-2438.771 -1301.878)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_195",
    "data-name": "<Path>",
    d: "M2489.9,1340.452l-4.657,2.7-.046-16.252,4.656-2.7Z",
    transform: "translate(-2448.924 -1289.161)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_196",
    "data-name": "<Path>",
    d: "M2432.757,1372.537l-4.61,2.654-.047-4.238,4.657-2.654Z",
    transform: "translate(-2418.414 -1312.724)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_197",
    "data-name": "<Path>",
    d: "M2451.756,1346.751l-4.61,2.7L2447.1,1342l4.657-2.7Z",
    transform: "translate(-2428.565 -1297.229)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_198",
    "data-name": "<Path>",
    d: "M2470.857,1340.68l-4.657,2.654v-6.38l4.657-2.654Z",
    transform: "translate(-2438.771 -1294.558)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_199",
    "data-name": "<Path>",
    d: "M2489.8,1312.712l-4.657,2.7-.047-10.058,4.657-2.654Z",
    transform: "translate(-2448.869 -1277.673)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_200",
    "data-name": "<Path>",
    d: "M2424.97,1314.1l-4.47,2.608v-2l4.47-2.608Z",
    transform: "translate(-2414.353 -1282.695)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_201",
    "data-name": "<Path>",
    d: "M2424.97,1323.3l-4.424,2.608-.046-2.049,4.47-2.561Z",
    transform: "translate(-2414.353 -1287.611)",
    fill: "#fdf7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_202",
    "data-name": "<Path>",
    d: "M2443.618,1301.1a1.575,1.575,0,0,1-.745,1.257l-5.728,3.353c-.419.233-.745.047-.745-.419a1.658,1.658,0,0,1,.745-1.3l5.728-3.306c.419-.233.745-.047.745.419Z",
    transform: "translate(-2422.849 -1276.542)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_203",
    "data-name": "<Path>",
    d: "M2454.7,1297.868l.047.093.093.093.047.14v.187a1.315,1.315,0,0,1-.186.7,1.294,1.294,0,0,1-.558.559.428.428,0,0,1-.513.047.465.465,0,0,1-.233-.466l.047-.186v-.186l.093-.186.093-.186a1.351,1.351,0,0,1,.513-.512A.614.614,0,0,1,2454.7,1297.868Z",
    transform: "translate(-2431.932 -1275.076)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_204",
    "data-name": "<Path>",
    d: "M2466.781,1286.98a1.575,1.575,0,0,1-.745,1.257l-6.892,4c-.419.233-.745.047-.745-.419a1.658,1.658,0,0,1,.745-1.3l6.892-3.958C2466.409,1286.282,2466.781,1286.515,2466.781,1286.98Z",
    transform: "translate(-2434.604 -1268.985)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_205",
    "data-name": "<Path>",
    d: "M2449.765,1302.7a1.575,1.575,0,0,1-.745,1.257l-11.875,6.892c-.419.233-.745.046-.745-.419a1.589,1.589,0,0,1,.745-1.3l11.875-6.846C2449.438,1302.052,2449.765,1302.238,2449.765,1302.7Z",
    transform: "translate(-2422.848 -1277.397)",
    fill: "#a5ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_206",
    "data-name": "<Path>",
    d: "M2471.537,1296.152a1.575,1.575,0,0,1-.745,1.257l-2.747,1.583c-.419.233-.745.047-.745-.419a1.732,1.732,0,0,1,.745-1.3l2.747-1.583C2471.211,1295.453,2471.537,1295.64,2471.537,1296.152Z",
    transform: "translate(-2439.359 -1273.872)",
    fill: "#a5ffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_108",
    "data-name": "<Group>",
    transform: "translate(30.548 384.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_109",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_110",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_111",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_207",
    "data-name": "<Path>",
    d: "M2169.336,1536.214l-10.245,5.961-10.292-5.961,10.292-5.914Z",
    transform: "translate(-2148.799 -1530.3)",
    fill: "url(#linear-gradient-62)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_208",
    "data-name": "<Path>",
    d: "M2181.145,1543v145.524l-10.245,5.914V1548.96Z",
    transform: "translate(-2160.608 -1537.086)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_209",
    "data-name": "<Path>",
    d: "M2159.091,1548.961v145.478l-10.292-5.914V1543Z",
    transform: "translate(-2148.799 -1537.086)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_210",
    "data-name": "<Path>",
    d: "M2169.336,1536.214v145.524l-10.245,5.914-10.292-5.914V1536.214l10.292-5.914Z",
    transform: "translate(-2148.799 -1530.3)",
    fill: "url(#linear-gradient-65)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg);
export default __webpack_public_path__ + "static/media/hero_img.95f2d96e70a229750bd31c1f90574868.svg";
export { ForwardRef as ReactComponent };